function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Plugin, PluginKey, TextSelection, Selection, AllSelection, NodeSelection, EditorState } from '@tiptap/pm/state';
import { EditorView } from '@tiptap/pm/view';
import { keymap } from '@tiptap/pm/keymap';
import { Schema, DOMSerializer, Fragment, Node as Node$1, DOMParser, Slice } from '@tiptap/pm/model';
import { liftTarget, ReplaceStep, ReplaceAroundStep, joinPoint, Transform, canSplit, canJoin, findWrapping } from '@tiptap/pm/transform';
import { createParagraphNear as createParagraphNear$1, deleteSelection as deleteSelection$1, exitCode as exitCode$1, joinUp as joinUp$1, joinDown as joinDown$1, joinBackward as joinBackward$1, joinForward as joinForward$1, joinTextblockBackward as joinTextblockBackward$1, joinTextblockForward as joinTextblockForward$1, lift as lift$1, liftEmptyBlock as liftEmptyBlock$1, newlineInCode as newlineInCode$1, selectNodeBackward as selectNodeBackward$1, selectNodeForward as selectNodeForward$1, selectParentNode as selectParentNode$1, selectTextblockEnd as selectTextblockEnd$1, selectTextblockStart as selectTextblockStart$1, setBlockType, wrapIn as wrapIn$1 } from '@tiptap/pm/commands';
import { liftListItem as liftListItem$1, sinkListItem as sinkListItem$1, wrapInList as wrapInList$1 } from '@tiptap/pm/schema-list';
/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */

function createChainableState(config) {
  var state = config.state,
      transaction = config.transaction;
  var selection = transaction.selection;
  var doc = transaction.doc;
  var storedMarks = transaction.storedMarks;
  return _objectSpread(_objectSpread({}, state), {}, {
    apply: state.apply.bind(state),
    applyTransaction: state.applyTransaction.bind(state),
    plugins: state.plugins,
    schema: state.schema,
    reconfigure: state.reconfigure.bind(state),
    toJSON: state.toJSON.bind(state),

    get storedMarks() {
      return storedMarks;
    },

    get selection() {
      return selection;
    },

    get doc() {
      return doc;
    },

    get tr() {
      selection = transaction.selection;
      doc = transaction.doc;
      storedMarks = transaction.storedMarks;
      return transaction;
    }

  });
}

var CommandManager = /*#__PURE__*/function () {
  function CommandManager(props) {
    _classCallCheck(this, CommandManager);

    this.editor = props.editor;
    this.rawCommands = this.editor.extensionManager.commands;
    this.customState = props.state;
  }

  _createClass(CommandManager, [{
    key: "hasCustomState",
    get: function get() {
      return !!this.customState;
    }
  }, {
    key: "state",
    get: function get() {
      return this.customState || this.editor.state;
    }
  }, {
    key: "commands",
    get: function get() {
      var _this = this;

      var rawCommands = this.rawCommands,
          editor = this.editor,
          state = this.state;
      var view = editor.view;
      var tr = state.tr;
      var props = this.buildProps(tr);
      return Object.fromEntries(Object.entries(rawCommands).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            command = _ref2[1];

        var method = function method() {
          var callback = command.apply(void 0, arguments)(props);

          if (!tr.getMeta('preventDispatch') && !_this.hasCustomState) {
            view.dispatch(tr);
          }

          return callback;
        };

        return [name, method];
      }));
    }
  }, {
    key: "chain",
    get: function get() {
      var _this2 = this;

      return function () {
        return _this2.createChain();
      };
    }
  }, {
    key: "can",
    get: function get() {
      var _this3 = this;

      return function () {
        return _this3.createCan();
      };
    }
  }, {
    key: "createChain",
    value: function createChain(startTr) {
      var _this4 = this;

      var shouldDispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var rawCommands = this.rawCommands,
          editor = this.editor,
          state = this.state;
      var view = editor.view;
      var callbacks = [];
      var hasStartTransaction = !!startTr;
      var tr = startTr || state.tr;

      var run = function run() {
        if (!hasStartTransaction && shouldDispatch && !tr.getMeta('preventDispatch') && !_this4.hasCustomState) {
          view.dispatch(tr);
        }

        return callbacks.every(function (callback) {
          return callback === true;
        });
      };

      var chain = _objectSpread(_objectSpread({}, Object.fromEntries(Object.entries(rawCommands).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            name = _ref4[0],
            command = _ref4[1];

        var chainedCommand = function chainedCommand() {
          var props = _this4.buildProps(tr, shouldDispatch);

          var callback = command.apply(void 0, arguments)(props);
          callbacks.push(callback);
          return chain;
        };

        return [name, chainedCommand];
      }))), {}, {
        run: run
      });

      return chain;
    }
  }, {
    key: "createCan",
    value: function createCan(startTr) {
      var _this5 = this;

      var rawCommands = this.rawCommands,
          state = this.state;
      var dispatch = false;
      var tr = startTr || state.tr;
      var props = this.buildProps(tr, dispatch);
      var formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            name = _ref6[0],
            command = _ref6[1];

        return [name, function () {
          return command.apply(void 0, arguments)(_objectSpread(_objectSpread({}, props), {}, {
            dispatch: undefined
          }));
        }];
      }));
      return _objectSpread(_objectSpread({}, formattedCommands), {}, {
        chain: function chain() {
          return _this5.createChain(tr, dispatch);
        }
      });
    }
  }, {
    key: "buildProps",
    value: function buildProps(tr) {
      var _this6 = this;

      var shouldDispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var rawCommands = this.rawCommands,
          editor = this.editor,
          state = this.state;
      var view = editor.view;
      var props = {
        tr: tr,
        editor: editor,
        view: view,
        state: createChainableState({
          state: state,
          transaction: tr
        }),
        dispatch: shouldDispatch ? function () {
          return undefined;
        } : undefined,
        chain: function chain() {
          return _this6.createChain(tr, shouldDispatch);
        },
        can: function can() {
          return _this6.createCan(tr);
        },

        get commands() {
          return Object.fromEntries(Object.entries(rawCommands).map(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
                name = _ref8[0],
                command = _ref8[1];

            return [name, function () {
              return command.apply(void 0, arguments)(props);
            }];
          }));
        }

      };
      return props;
    }
  }]);

  return CommandManager;
}();

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.callbacks = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(event, fn) {
      if (!this.callbacks[event]) {
        this.callbacks[event] = [];
      }

      this.callbacks[event].push(fn);
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this7 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var callbacks = this.callbacks[event];

      if (callbacks) {
        callbacks.forEach(function (callback) {
          return callback.apply(_this7, args);
        });
      }

      return this;
    }
  }, {
    key: "off",
    value: function off(event, fn) {
      var callbacks = this.callbacks[event];

      if (callbacks) {
        if (fn) {
          this.callbacks[event] = callbacks.filter(function (callback) {
            return callback !== fn;
          });
        } else {
          delete this.callbacks[event];
        }
      }

      return this;
    }
  }, {
    key: "once",
    value: function once(event, fn) {
      var _this8 = this;

      var onceFn = function onceFn() {
        _this8.off(event, onceFn);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        fn.apply(_this8, args);
      };

      return this.on(event, onceFn);
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners() {
      this.callbacks = {};
    }
  }]);

  return EventEmitter;
}();
/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */


function getExtensionField(extension, field, context) {
  if (extension.config[field] === undefined && extension.parent) {
    return getExtensionField(extension.parent, field, context);
  }

  if (typeof extension.config[field] === 'function') {
    var value = extension.config[field].bind(_objectSpread(_objectSpread({}, context), {}, {
      parent: extension.parent ? getExtensionField(extension.parent, field, context) : null
    }));
    return value;
  }

  return extension.config[field];
}

function splitExtensions(extensions) {
  var baseExtensions = extensions.filter(function (extension) {
    return extension.type === 'extension';
  });
  var nodeExtensions = extensions.filter(function (extension) {
    return extension.type === 'node';
  });
  var markExtensions = extensions.filter(function (extension) {
    return extension.type === 'mark';
  });
  return {
    baseExtensions: baseExtensions,
    nodeExtensions: nodeExtensions,
    markExtensions: markExtensions
  };
}
/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */


function getAttributesFromExtensions(extensions) {
  var extensionAttributes = [];

  var _splitExtensions = splitExtensions(extensions),
      nodeExtensions = _splitExtensions.nodeExtensions,
      markExtensions = _splitExtensions.markExtensions;

  var nodeAndMarkExtensions = [].concat(_toConsumableArray(nodeExtensions), _toConsumableArray(markExtensions));
  var defaultAttribute = {
    default: null,
    rendered: true,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: true,
    isRequired: false
  };
  extensions.forEach(function (extension) {
    var context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage,
      extensions: nodeAndMarkExtensions
    };
    var addGlobalAttributes = getExtensionField(extension, 'addGlobalAttributes', context);

    if (!addGlobalAttributes) {
      return;
    }

    var globalAttributes = addGlobalAttributes();
    globalAttributes.forEach(function (globalAttribute) {
      globalAttribute.types.forEach(function (type) {
        Object.entries(globalAttribute.attributes).forEach(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 2),
              name = _ref10[0],
              attribute = _ref10[1];

          extensionAttributes.push({
            type: type,
            name: name,
            attribute: _objectSpread(_objectSpread({}, defaultAttribute), attribute)
          });
        });
      });
    });
  });
  nodeAndMarkExtensions.forEach(function (extension) {
    var context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage
    };
    var addAttributes = getExtensionField(extension, 'addAttributes', context);

    if (!addAttributes) {
      return;
    } // TODO: remove `as Attributes`


    var attributes = addAttributes();
    Object.entries(attributes).forEach(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
          name = _ref12[0],
          attribute = _ref12[1];

      var mergedAttr = _objectSpread(_objectSpread({}, defaultAttribute), attribute);

      if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === 'function') {
        mergedAttr.default = mergedAttr.default();
      }

      if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) {
        delete mergedAttr.default;
      }

      extensionAttributes.push({
        type: extension.name,
        name: name,
        attribute: mergedAttr
      });
    });
  });
  return extensionAttributes;
}

function getNodeType(nameOrType, schema) {
  if (typeof nameOrType === 'string') {
    if (!schema.nodes[nameOrType]) {
      throw Error("There is no node type named '".concat(nameOrType, "'. Maybe you forgot to add the extension?"));
    }

    return schema.nodes[nameOrType];
  }

  return nameOrType;
}

function mergeAttributes() {
  for (var _len3 = arguments.length, objects = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    objects[_key3] = arguments[_key3];
  }

  return objects.filter(function (item) {
    return !!item;
  }).reduce(function (items, item) {
    var mergedAttributes = _objectSpread({}, items);

    Object.entries(item).forEach(function (_ref13) {
      var _ref14 = _slicedToArray(_ref13, 2),
          key = _ref14[0],
          value = _ref14[1];

      var exists = mergedAttributes[key];

      if (!exists) {
        mergedAttributes[key] = value;
        return;
      }

      if (key === 'class') {
        var valueClasses = value ? String(value).split(' ') : [];
        var existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(' ') : [];
        var insertClasses = valueClasses.filter(function (valueClass) {
          return !existingClasses.includes(valueClass);
        });
        mergedAttributes[key] = [].concat(_toConsumableArray(existingClasses), _toConsumableArray(insertClasses)).join(' ');
      } else if (key === 'style') {
        var newStyles = value ? value.split(';').map(function (style) {
          return style.trim();
        }).filter(Boolean) : [];
        var existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(';').map(function (style) {
          return style.trim();
        }).filter(Boolean) : [];
        var styleMap = new Map();
        existingStyles.forEach(function (style) {
          var _style$split$map = style.split(':').map(function (part) {
            return part.trim();
          }),
              _style$split$map2 = _slicedToArray(_style$split$map, 2),
              property = _style$split$map2[0],
              val = _style$split$map2[1];

          styleMap.set(property, val);
        });
        newStyles.forEach(function (style) {
          var _style$split$map3 = style.split(':').map(function (part) {
            return part.trim();
          }),
              _style$split$map4 = _slicedToArray(_style$split$map3, 2),
              property = _style$split$map4[0],
              val = _style$split$map4[1];

          styleMap.set(property, val);
        });
        mergedAttributes[key] = Array.from(styleMap.entries()).map(function (_ref15) {
          var _ref16 = _slicedToArray(_ref15, 2),
              property = _ref16[0],
              val = _ref16[1];

          return "".concat(property, ": ").concat(val);
        }).join('; ');
      } else {
        mergedAttributes[key] = value;
      }
    });
    return mergedAttributes;
  }, {});
}

function getRenderedAttributes(nodeOrMark, extensionAttributes) {
  return extensionAttributes.filter(function (attribute) {
    return attribute.type === nodeOrMark.type.name;
  }).filter(function (item) {
    return item.attribute.rendered;
  }).map(function (item) {
    if (!item.attribute.renderHTML) {
      return _defineProperty({}, item.name, nodeOrMark.attrs[item.name]);
    }

    return item.attribute.renderHTML(nodeOrMark.attrs) || {};
  }).reduce(function (attributes, attribute) {
    return mergeAttributes(attributes, attribute);
  }, {});
} // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type


function isFunction(value) {
  return typeof value === 'function';
}
/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */


function callOrReturn(value) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (isFunction(value)) {
    for (var _len4 = arguments.length, props = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
      props[_key4 - 2] = arguments[_key4];
    }

    if (context) {
      return value.bind(context).apply(void 0, props);
    }

    return value.apply(void 0, props);
  }

  return value;
}

function isEmptyObject() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(value).length === 0 && value.constructor === Object;
}

function fromString(value) {
  if (typeof value !== 'string') {
    return value;
  }

  if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) {
    return Number(value);
  }

  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return value;
}
/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */


function injectExtensionAttributesToParseRule(parseRule, extensionAttributes) {
  if ('style' in parseRule) {
    return parseRule;
  }

  return _objectSpread(_objectSpread({}, parseRule), {}, {
    getAttrs: function getAttrs(node) {
      var oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;

      if (oldAttributes === false) {
        return false;
      }

      var newAttributes = extensionAttributes.reduce(function (items, item) {
        var value = item.attribute.parseHTML ? item.attribute.parseHTML(node) : fromString(node.getAttribute(item.name));

        if (value === null || value === undefined) {
          return items;
        }

        return _objectSpread(_objectSpread({}, items), {}, _defineProperty({}, item.name, value));
      }, {});
      return _objectSpread(_objectSpread({}, oldAttributes), newAttributes);
    }
  });
}

function cleanUpSchemaItem(data) {
  return Object.fromEntries( // @ts-ignore
  Object.entries(data).filter(function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
        key = _ref19[0],
        value = _ref19[1];

    if (key === 'attrs' && isEmptyObject(value)) {
      return false;
    }

    return value !== null && value !== undefined;
  }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */


function getSchemaByResolvedExtensions(extensions, editor) {
  var _a;

  var allAttributes = getAttributesFromExtensions(extensions);

  var _splitExtensions2 = splitExtensions(extensions),
      nodeExtensions = _splitExtensions2.nodeExtensions,
      markExtensions = _splitExtensions2.markExtensions;

  var topNode = (_a = nodeExtensions.find(function (extension) {
    return getExtensionField(extension, 'topNode');
  })) === null || _a === void 0 ? void 0 : _a.name;
  var nodes = Object.fromEntries(nodeExtensions.map(function (extension) {
    var extensionAttributes = allAttributes.filter(function (attribute) {
      return attribute.type === extension.name;
    });
    var context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage,
      editor: editor
    };
    var extraNodeFields = extensions.reduce(function (fields, e) {
      var extendNodeSchema = getExtensionField(e, 'extendNodeSchema', context);
      return _objectSpread(_objectSpread({}, fields), extendNodeSchema ? extendNodeSchema(extension) : {});
    }, {});
    var schema = cleanUpSchemaItem(_objectSpread(_objectSpread({}, extraNodeFields), {}, {
      content: callOrReturn(getExtensionField(extension, 'content', context)),
      marks: callOrReturn(getExtensionField(extension, 'marks', context)),
      group: callOrReturn(getExtensionField(extension, 'group', context)),
      inline: callOrReturn(getExtensionField(extension, 'inline', context)),
      atom: callOrReturn(getExtensionField(extension, 'atom', context)),
      selectable: callOrReturn(getExtensionField(extension, 'selectable', context)),
      draggable: callOrReturn(getExtensionField(extension, 'draggable', context)),
      code: callOrReturn(getExtensionField(extension, 'code', context)),
      whitespace: callOrReturn(getExtensionField(extension, 'whitespace', context)),
      linebreakReplacement: callOrReturn(getExtensionField(extension, 'linebreakReplacement', context)),
      defining: callOrReturn(getExtensionField(extension, 'defining', context)),
      isolating: callOrReturn(getExtensionField(extension, 'isolating', context)),
      attrs: Object.fromEntries(extensionAttributes.map(function (extensionAttribute) {
        var _a;

        return [extensionAttribute.name, {
          default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
        }];
      }))
    }));
    var parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));

    if (parseHTML) {
      schema.parseDOM = parseHTML.map(function (parseRule) {
        return injectExtensionAttributesToParseRule(parseRule, extensionAttributes);
      });
    }

    var renderHTML = getExtensionField(extension, 'renderHTML', context);

    if (renderHTML) {
      schema.toDOM = function (node) {
        return renderHTML({
          node: node,
          HTMLAttributes: getRenderedAttributes(node, extensionAttributes)
        });
      };
    }

    var renderText = getExtensionField(extension, 'renderText', context);

    if (renderText) {
      schema.toText = renderText;
    }

    return [extension.name, schema];
  }));
  var marks = Object.fromEntries(markExtensions.map(function (extension) {
    var extensionAttributes = allAttributes.filter(function (attribute) {
      return attribute.type === extension.name;
    });
    var context = {
      name: extension.name,
      options: extension.options,
      storage: extension.storage,
      editor: editor
    };
    var extraMarkFields = extensions.reduce(function (fields, e) {
      var extendMarkSchema = getExtensionField(e, 'extendMarkSchema', context);
      return _objectSpread(_objectSpread({}, fields), extendMarkSchema ? extendMarkSchema(extension) : {});
    }, {});
    var schema = cleanUpSchemaItem(_objectSpread(_objectSpread({}, extraMarkFields), {}, {
      inclusive: callOrReturn(getExtensionField(extension, 'inclusive', context)),
      excludes: callOrReturn(getExtensionField(extension, 'excludes', context)),
      group: callOrReturn(getExtensionField(extension, 'group', context)),
      spanning: callOrReturn(getExtensionField(extension, 'spanning', context)),
      code: callOrReturn(getExtensionField(extension, 'code', context)),
      attrs: Object.fromEntries(extensionAttributes.map(function (extensionAttribute) {
        var _a;

        return [extensionAttribute.name, {
          default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
        }];
      }))
    }));
    var parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));

    if (parseHTML) {
      schema.parseDOM = parseHTML.map(function (parseRule) {
        return injectExtensionAttributesToParseRule(parseRule, extensionAttributes);
      });
    }

    var renderHTML = getExtensionField(extension, 'renderHTML', context);

    if (renderHTML) {
      schema.toDOM = function (mark) {
        return renderHTML({
          mark: mark,
          HTMLAttributes: getRenderedAttributes(mark, extensionAttributes)
        });
      };
    }

    return [extension.name, schema];
  }));
  return new Schema({
    topNode: topNode,
    nodes: nodes,
    marks: marks
  });
}
/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */


function getSchemaTypeByName(name, schema) {
  return schema.nodes[name] || schema.marks[name] || null;
}

function isExtensionRulesEnabled(extension, enabled) {
  if (Array.isArray(enabled)) {
    return enabled.some(function (enabledExtension) {
      var name = typeof enabledExtension === 'string' ? enabledExtension : enabledExtension.name;
      return name === extension.name;
    });
  }

  return enabled;
}

function getHTMLFromFragment(fragment, schema) {
  var documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment);
  var temporaryDocument = document.implementation.createHTMLDocument();
  var container = temporaryDocument.createElement('div');
  container.appendChild(documentFragment);
  return container.innerHTML;
}
/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */


var getTextContentFromNodes = function getTextContentFromNodes($from) {
  var maxMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var textBefore = '';
  var sliceEndPos = $from.parentOffset;
  $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, function (node, pos, parent, index) {
    var _a, _b;

    var chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
      node: node,
      pos: pos,
      parent: parent,
      index: index
    })) || node.textContent || '%leaf%';
    textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
  });
  return textBefore;
};

function isRegExp(value) {
  return Object.prototype.toString.call(value) === '[object RegExp]';
}

var InputRule = function InputRule(config) {
  _classCallCheck(this, InputRule);

  this.find = config.find;
  this.handler = config.handler;
};

var inputRuleMatcherHandler = function inputRuleMatcherHandler(text, find) {
  if (isRegExp(find)) {
    return find.exec(text);
  }

  var inputRuleMatch = find(text);

  if (!inputRuleMatch) {
    return null;
  }

  var result = [inputRuleMatch.text];
  result.index = inputRuleMatch.index;
  result.input = text;
  result.data = inputRuleMatch.data;

  if (inputRuleMatch.replaceWith) {
    if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) {
      console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
    }

    result.push(inputRuleMatch.replaceWith);
  }

  return result;
};

function run$1(config) {
  var _a;

  var editor = config.editor,
      from = config.from,
      to = config.to,
      text = config.text,
      rules = config.rules,
      plugin = config.plugin;
  var view = editor.view;

  if (view.composing) {
    return false;
  }

  var $from = view.state.doc.resolve(from);

  if ( // check for code node
  $from.parent.type.spec.code // check for code mark
  || !!((_a = $from.nodeBefore || $from.nodeAfter) === null || _a === void 0 ? void 0 : _a.marks.find(function (mark) {
    return mark.type.spec.code;
  }))) {
    return false;
  }

  var matched = false;
  var textBefore = getTextContentFromNodes($from) + text;
  rules.forEach(function (rule) {
    if (matched) {
      return;
    }

    var match = inputRuleMatcherHandler(textBefore, rule.find);

    if (!match) {
      return;
    }

    var tr = view.state.tr;
    var state = createChainableState({
      state: view.state,
      transaction: tr
    });
    var range = {
      from: from - (match[0].length - text.length),
      to: to
    };

    var _CommandManager = new CommandManager({
      editor: editor,
      state: state
    }),
        commands = _CommandManager.commands,
        chain = _CommandManager.chain,
        can = _CommandManager.can;

    var handler = rule.handler({
      state: state,
      range: range,
      match: match,
      commands: commands,
      chain: chain,
      can: can
    }); // stop if there are no changes

    if (handler === null || !tr.steps.length) {
      return;
    } // store transform as meta data
    // so we can undo input rules within the `undoInputRules` command


    tr.setMeta(plugin, {
      transform: tr,
      from: from,
      to: to,
      text: text
    });
    view.dispatch(tr);
    matched = true;
  });
  return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */


function inputRulesPlugin(props) {
  var editor = props.editor,
      rules = props.rules;
  var plugin = new Plugin({
    state: {
      init: function init() {
        return null;
      },
      apply: function apply(tr, prev, state) {
        var stored = tr.getMeta(plugin);

        if (stored) {
          return stored;
        } // if InputRule is triggered by insertContent()


        var simulatedInputMeta = tr.getMeta('applyInputRules');
        var isSimulatedInput = !!simulatedInputMeta;

        if (isSimulatedInput) {
          setTimeout(function () {
            var text = simulatedInputMeta.text;

            if (typeof text === 'string') {
              text = text;
            } else {
              text = getHTMLFromFragment(Fragment.from(text), state.schema);
            }

            var from = simulatedInputMeta.from;
            var to = from + text.length;
            run$1({
              editor: editor,
              from: from,
              to: to,
              text: text,
              rules: rules,
              plugin: plugin
            });
          });
        }

        return tr.selectionSet || tr.docChanged ? null : prev;
      }
    },
    props: {
      handleTextInput: function handleTextInput(view, from, to, text) {
        return run$1({
          editor: editor,
          from: from,
          to: to,
          text: text,
          rules: rules,
          plugin: plugin
        });
      },
      handleDOMEvents: {
        compositionend: function compositionend(view) {
          setTimeout(function () {
            var $cursor = view.state.selection.$cursor;

            if ($cursor) {
              run$1({
                editor: editor,
                from: $cursor.pos,
                to: $cursor.pos,
                text: '',
                rules: rules,
                plugin: plugin
              });
            }
          });
          return false;
        }
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown: function handleKeyDown(view, event) {
        if (event.key !== 'Enter') {
          return false;
        }

        var $cursor = view.state.selection.$cursor;

        if ($cursor) {
          return run$1({
            editor: editor,
            from: $cursor.pos,
            to: $cursor.pos,
            text: '\n',
            rules: rules,
            plugin: plugin
          });
        }

        return false;
      }
    },
    // @ts-ignore
    isInputRules: true
  });
  return plugin;
} // see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts


function getType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
}

function isPlainObject(value) {
  if (getType(value) !== 'Object') {
    return false;
  }

  return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}

function mergeDeep(target, source) {
  var output = _objectSpread({}, target);

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isPlainObject(source[key]) && isPlainObject(target[key])) {
        output[key] = mergeDeep(target[key], source[key]);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}
/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */


var Mark = /*#__PURE__*/function () {
  function Mark() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Mark);

    this.type = 'mark';
    this.name = 'mark';
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = _objectSpread(_objectSpread({}, this.config), config);
    this.name = this.config.name;

    if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
      console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(this.name, "\"."));
    } // TODO: remove `addOptions` fallback


    this.options = this.config.defaultOptions;

    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, 'addOptions', {
        name: this.name
      }));
    }

    this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
      name: this.name,
      options: this.options
    })) || {};
  }

  _createClass(Mark, [{
    key: "configure",
    value: function configure() {
      var _this9 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // return a new instance so we can use the same extension
      // with different calls of `configure`
      var extension = this.extend(_objectSpread(_objectSpread({}, this.config), {}, {
        addOptions: function addOptions() {
          return mergeDeep(_this9.options, options);
        }
      })); // Always preserve the current name

      extension.name = this.name; // Set the parent to be our parent

      extension.parent = this.parent;
      return extension;
    }
  }, {
    key: "extend",
    value: function extend() {
      var extendedConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var extension = new Mark(extendedConfig);
      extension.parent = this;
      this.child = extension;
      extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;

      if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
        console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(extension.name, "\"."));
      }

      extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
        name: extension.name
      }));
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }], [{
    key: "create",
    value: function create() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Mark(config);
    }
  }, {
    key: "handleExit",
    value: function handleExit(_ref20) {
      var editor = _ref20.editor,
          mark = _ref20.mark;
      var tr = editor.state.tr;
      var currentPos = editor.state.selection.$from;
      var isAtEnd = currentPos.pos === currentPos.end();

      if (isAtEnd) {
        var currentMarks = currentPos.marks();
        var isInMark = !!currentMarks.find(function (m) {
          return (m === null || m === void 0 ? void 0 : m.type.name) === mark.name;
        });

        if (!isInMark) {
          return false;
        }

        var removeMark = currentMarks.find(function (m) {
          return (m === null || m === void 0 ? void 0 : m.type.name) === mark.name;
        });

        if (removeMark) {
          tr.removeStoredMark(removeMark);
        }

        tr.insertText(' ', currentPos.pos);
        editor.view.dispatch(tr);
        return true;
      }

      return false;
    }
  }]);

  return Mark;
}();

function isNumber(value) {
  return typeof value === 'number';
}
/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */


var PasteRule = function PasteRule(config) {
  _classCallCheck(this, PasteRule);

  this.find = config.find;
  this.handler = config.handler;
};

var pasteRuleMatcherHandler = function pasteRuleMatcherHandler(text, find, event) {
  if (isRegExp(find)) {
    return _toConsumableArray(text.matchAll(find));
  }

  var matches = find(text, event);

  if (!matches) {
    return [];
  }

  return matches.map(function (pasteRuleMatch) {
    var result = [pasteRuleMatch.text];
    result.index = pasteRuleMatch.index;
    result.input = text;
    result.data = pasteRuleMatch.data;

    if (pasteRuleMatch.replaceWith) {
      if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) {
        console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
      }

      result.push(pasteRuleMatch.replaceWith);
    }

    return result;
  });
};

function run(config) {
  var editor = config.editor,
      state = config.state,
      from = config.from,
      to = config.to,
      rule = config.rule,
      pasteEvent = config.pasteEvent,
      dropEvent = config.dropEvent;

  var _CommandManager2 = new CommandManager({
    editor: editor,
    state: state
  }),
      commands = _CommandManager2.commands,
      chain = _CommandManager2.chain,
      can = _CommandManager2.can;

  var handlers = [];
  state.doc.nodesBetween(from, to, function (node, pos) {
    if (!node.isTextblock || node.type.spec.code) {
      return;
    }

    var resolvedFrom = Math.max(from, pos);
    var resolvedTo = Math.min(to, pos + node.content.size);
    var textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, "\uFFFC");
    var matches = pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
    matches.forEach(function (match) {
      if (match.index === undefined) {
        return;
      }

      var start = resolvedFrom + match.index + 1;
      var end = start + match[0].length;
      var range = {
        from: state.tr.mapping.map(start),
        to: state.tr.mapping.map(end)
      };
      var handler = rule.handler({
        state: state,
        range: range,
        match: match,
        commands: commands,
        chain: chain,
        can: can,
        pasteEvent: pasteEvent,
        dropEvent: dropEvent
      });
      handlers.push(handler);
    });
  });
  var success = handlers.every(function (handler) {
    return handler !== null;
  });
  return success;
} // When dragging across editors, must get another editor instance to delete selection content.


var tiptapDragFromOtherEditor = null;

var createClipboardPasteEvent = function createClipboardPasteEvent(text) {
  var _a;

  var event = new ClipboardEvent('paste', {
    clipboardData: new DataTransfer()
  });
  (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.setData('text/html', text);
  return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */


function pasteRulesPlugin(props) {
  var editor = props.editor,
      rules = props.rules;
  var dragSourceElement = null;
  var isPastedFromProseMirror = false;
  var isDroppedFromProseMirror = false;
  var pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
  var dropEvent;

  try {
    dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
  } catch (_unused) {
    dropEvent = null;
  }

  var processEvent = function processEvent(_ref21) {
    var state = _ref21.state,
        from = _ref21.from,
        to = _ref21.to,
        rule = _ref21.rule,
        pasteEvt = _ref21.pasteEvt;
    var tr = state.tr;
    var chainableState = createChainableState({
      state: state,
      transaction: tr
    });
    var handler = run({
      editor: editor,
      state: chainableState,
      from: Math.max(from - 1, 0),
      to: to.b - 1,
      rule: rule,
      pasteEvent: pasteEvt,
      dropEvent: dropEvent
    });

    if (!handler || !tr.steps.length) {
      return;
    }

    try {
      dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
    } catch (_unused2) {
      dropEvent = null;
    }

    pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
    return tr;
  };

  var plugins = rules.map(function (rule) {
    return new Plugin({
      // we register a global drag handler to track the current drag source element
      view: function view(_view2) {
        var handleDragstart = function handleDragstart(event) {
          var _a;

          dragSourceElement = ((_a = _view2.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ? _view2.dom.parentElement : null;

          if (dragSourceElement) {
            tiptapDragFromOtherEditor = editor;
          }
        };

        var handleDragend = function handleDragend() {
          if (tiptapDragFromOtherEditor) {
            tiptapDragFromOtherEditor = null;
          }
        };

        window.addEventListener('dragstart', handleDragstart);
        window.addEventListener('dragend', handleDragend);
        return {
          destroy: function destroy() {
            window.removeEventListener('dragstart', handleDragstart);
            window.removeEventListener('dragend', handleDragend);
          }
        };
      },
      props: {
        handleDOMEvents: {
          drop: function drop(view, event) {
            isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
            dropEvent = event;

            if (!isDroppedFromProseMirror) {
              var dragFromOtherEditor = tiptapDragFromOtherEditor;

              if (dragFromOtherEditor) {
                // setTimeout to avoid the wrong content after drop, timeout arg can't be empty or 0
                setTimeout(function () {
                  var selection = dragFromOtherEditor.state.selection;

                  if (selection) {
                    dragFromOtherEditor.commands.deleteRange({
                      from: selection.from,
                      to: selection.to
                    });
                  }
                }, 10);
              }
            }

            return false;
          },
          paste: function paste(_view, event) {
            var _a;

            var html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
            pasteEvent = event;
            isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes('data-pm-slice'));
            return false;
          }
        }
      },
      appendTransaction: function appendTransaction(transactions, oldState, state) {
        var transaction = transactions[0];
        var isPaste = transaction.getMeta('uiEvent') === 'paste' && !isPastedFromProseMirror;
        var isDrop = transaction.getMeta('uiEvent') === 'drop' && !isDroppedFromProseMirror; // if PasteRule is triggered by insertContent()

        var simulatedPasteMeta = transaction.getMeta('applyPasteRules');
        var isSimulatedPaste = !!simulatedPasteMeta;

        if (!isPaste && !isDrop && !isSimulatedPaste) {
          return;
        } // Handle simulated paste


        if (isSimulatedPaste) {
          var text = simulatedPasteMeta.text;

          if (typeof text === 'string') {
            text = text;
          } else {
            text = getHTMLFromFragment(Fragment.from(text), state.schema);
          }

          var _from2 = simulatedPasteMeta.from;

          var _to2 = _from2 + text.length;

          var pasteEvt = createClipboardPasteEvent(text);
          return processEvent({
            rule: rule,
            state: state,
            from: _from2,
            to: {
              b: _to2
            },
            pasteEvt: pasteEvt
          });
        } // handle actual paste/drop


        var from = oldState.doc.content.findDiffStart(state.doc.content);
        var to = oldState.doc.content.findDiffEnd(state.doc.content); // stop if there is no changed range

        if (!isNumber(from) || !to || from === to.b) {
          return;
        }

        return processEvent({
          rule: rule,
          state: state,
          from: from,
          to: to,
          pasteEvt: pasteEvent
        });
      }
    });
  });
  return plugins;
}

function findDuplicates(items) {
  var filtered = items.filter(function (el, index) {
    return items.indexOf(el) !== index;
  });
  return Array.from(new Set(filtered));
}

var ExtensionManager = /*#__PURE__*/function () {
  function ExtensionManager(extensions, editor) {
    _classCallCheck(this, ExtensionManager);

    this.splittableMarks = [];
    this.editor = editor;
    this.extensions = ExtensionManager.resolve(extensions);
    this.schema = getSchemaByResolvedExtensions(this.extensions, editor);
    this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */


  _createClass(ExtensionManager, [{
    key: "commands",
    get:
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */
    function get() {
      var _this10 = this;

      return this.extensions.reduce(function (commands, extension) {
        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage,
          editor: _this10.editor,
          type: getSchemaTypeByName(extension.name, _this10.schema)
        };
        var addCommands = getExtensionField(extension, 'addCommands', context);

        if (!addCommands) {
          return commands;
        }

        return _objectSpread(_objectSpread({}, commands), addCommands());
      }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */

  }, {
    key: "plugins",
    get: function get() {
      var _this11 = this;

      var editor = this.editor; // With ProseMirror, first plugins within an array are executed first.
      // In Tiptap, we provide the ability to override plugins,
      // so it feels more natural to run plugins at the end of an array first.
      // That’s why we have to reverse the `extensions` array and sort again
      // based on the `priority` option.

      var extensions = ExtensionManager.sort(_toConsumableArray(this.extensions).reverse());
      var inputRules = [];
      var pasteRules = [];
      var allPlugins = extensions.map(function (extension) {
        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage,
          editor: editor,
          type: getSchemaTypeByName(extension.name, _this11.schema)
        };
        var plugins = [];
        var addKeyboardShortcuts = getExtensionField(extension, 'addKeyboardShortcuts', context);
        var defaultBindings = {}; // bind exit handling

        if (extension.type === 'mark' && getExtensionField(extension, 'exitable', context)) {
          defaultBindings.ArrowRight = function () {
            return Mark.handleExit({
              editor: editor,
              mark: extension
            });
          };
        }

        if (addKeyboardShortcuts) {
          var bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(function (_ref22) {
            var _ref23 = _slicedToArray(_ref22, 2),
                shortcut = _ref23[0],
                method = _ref23[1];

            return [shortcut, function () {
              return method({
                editor: editor
              });
            }];
          }));
          defaultBindings = _objectSpread(_objectSpread({}, defaultBindings), bindings);
        }

        var keyMapPlugin = keymap(defaultBindings);
        plugins.push(keyMapPlugin);
        var addInputRules = getExtensionField(extension, 'addInputRules', context);

        if (isExtensionRulesEnabled(extension, editor.options.enableInputRules) && addInputRules) {
          inputRules.push.apply(inputRules, _toConsumableArray(addInputRules()));
        }

        var addPasteRules = getExtensionField(extension, 'addPasteRules', context);

        if (isExtensionRulesEnabled(extension, editor.options.enablePasteRules) && addPasteRules) {
          pasteRules.push.apply(pasteRules, _toConsumableArray(addPasteRules()));
        }

        var addProseMirrorPlugins = getExtensionField(extension, 'addProseMirrorPlugins', context);

        if (addProseMirrorPlugins) {
          var proseMirrorPlugins = addProseMirrorPlugins();
          plugins.push.apply(plugins, _toConsumableArray(proseMirrorPlugins));
        }

        return plugins;
      }).flat();
      return [inputRulesPlugin({
        editor: editor,
        rules: inputRules
      })].concat(_toConsumableArray(pasteRulesPlugin({
        editor: editor,
        rules: pasteRules
      })), _toConsumableArray(allPlugins));
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */

  }, {
    key: "attributes",
    get: function get() {
      return getAttributesFromExtensions(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */

  }, {
    key: "nodeViews",
    get: function get() {
      var _this12 = this;

      var editor = this.editor;

      var _splitExtensions3 = splitExtensions(this.extensions),
          nodeExtensions = _splitExtensions3.nodeExtensions;

      return Object.fromEntries(nodeExtensions.filter(function (extension) {
        return !!getExtensionField(extension, 'addNodeView');
      }).map(function (extension) {
        var extensionAttributes = _this12.attributes.filter(function (attribute) {
          return attribute.type === extension.name;
        });

        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage,
          editor: editor,
          type: getNodeType(extension.name, _this12.schema)
        };
        var addNodeView = getExtensionField(extension, 'addNodeView', context);

        if (!addNodeView) {
          return [];
        }

        var nodeview = function nodeview(node, view, getPos, decorations, innerDecorations) {
          var HTMLAttributes = getRenderedAttributes(node, extensionAttributes);
          return addNodeView()({
            // pass-through
            node: node,
            view: view,
            getPos: getPos,
            decorations: decorations,
            innerDecorations: innerDecorations,
            // tiptap-specific
            editor: editor,
            extension: extension,
            HTMLAttributes: HTMLAttributes
          });
        };

        return [extension.name, nodeview];
      }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */

  }, {
    key: "setupExtensions",
    value: function setupExtensions() {
      var _this13 = this;

      this.extensions.forEach(function (extension) {
        var _a; // store extension storage in editor


        _this13.editor.extensionStorage[extension.name] = extension.storage;
        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage,
          editor: _this13.editor,
          type: getSchemaTypeByName(extension.name, _this13.schema)
        };

        if (extension.type === 'mark') {
          var keepOnSplit = (_a = callOrReturn(getExtensionField(extension, 'keepOnSplit', context))) !== null && _a !== void 0 ? _a : true;

          if (keepOnSplit) {
            _this13.splittableMarks.push(extension.name);
          }
        }

        var onBeforeCreate = getExtensionField(extension, 'onBeforeCreate', context);
        var onCreate = getExtensionField(extension, 'onCreate', context);
        var onUpdate = getExtensionField(extension, 'onUpdate', context);
        var onSelectionUpdate = getExtensionField(extension, 'onSelectionUpdate', context);
        var onTransaction = getExtensionField(extension, 'onTransaction', context);
        var onFocus = getExtensionField(extension, 'onFocus', context);
        var onBlur = getExtensionField(extension, 'onBlur', context);
        var onDestroy = getExtensionField(extension, 'onDestroy', context);

        if (onBeforeCreate) {
          _this13.editor.on('beforeCreate', onBeforeCreate);
        }

        if (onCreate) {
          _this13.editor.on('create', onCreate);
        }

        if (onUpdate) {
          _this13.editor.on('update', onUpdate);
        }

        if (onSelectionUpdate) {
          _this13.editor.on('selectionUpdate', onSelectionUpdate);
        }

        if (onTransaction) {
          _this13.editor.on('transaction', onTransaction);
        }

        if (onFocus) {
          _this13.editor.on('focus', onFocus);
        }

        if (onBlur) {
          _this13.editor.on('blur', onBlur);
        }

        if (onDestroy) {
          _this13.editor.on('destroy', onDestroy);
        }
      });
    }
  }], [{
    key: "resolve",
    value: function resolve(extensions) {
      var resolvedExtensions = ExtensionManager.sort(ExtensionManager.flatten(extensions));
      var duplicatedNames = findDuplicates(resolvedExtensions.map(function (extension) {
        return extension.name;
      }));

      if (duplicatedNames.length) {
        console.warn("[tiptap warn]: Duplicate extension names found: [".concat(duplicatedNames.map(function (item) {
          return "'".concat(item, "'");
        }).join(', '), "]. This can lead to issues."));
      }

      return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */

  }, {
    key: "flatten",
    value: function flatten(extensions) {
      var _this14 = this;

      return extensions.map(function (extension) {
        var context = {
          name: extension.name,
          options: extension.options,
          storage: extension.storage
        };
        var addExtensions = getExtensionField(extension, 'addExtensions', context);

        if (addExtensions) {
          return [extension].concat(_toConsumableArray(_this14.flatten(addExtensions())));
        }

        return extension;
      }) // `Infinity` will break TypeScript so we set a number that is probably high enough
      .flat(10);
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */

  }, {
    key: "sort",
    value: function sort(extensions) {
      var defaultPriority = 100;
      return extensions.sort(function (a, b) {
        var priorityA = getExtensionField(a, 'priority') || defaultPriority;
        var priorityB = getExtensionField(b, 'priority') || defaultPriority;

        if (priorityA > priorityB) {
          return -1;
        }

        if (priorityA < priorityB) {
          return 1;
        }

        return 0;
      });
    }
  }]);

  return ExtensionManager;
}();
/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */


var Extension = /*#__PURE__*/function () {
  function Extension() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Extension);

    this.type = 'extension';
    this.name = 'extension';
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = _objectSpread(_objectSpread({}, this.config), config);
    this.name = this.config.name;

    if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
      console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(this.name, "\"."));
    } // TODO: remove `addOptions` fallback


    this.options = this.config.defaultOptions;

    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, 'addOptions', {
        name: this.name
      }));
    }

    this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
      name: this.name,
      options: this.options
    })) || {};
  }

  _createClass(Extension, [{
    key: "configure",
    value: function configure() {
      var _this15 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // return a new instance so we can use the same extension
      // with different calls of `configure`
      var extension = this.extend(_objectSpread(_objectSpread({}, this.config), {}, {
        addOptions: function addOptions() {
          return mergeDeep(_this15.options, options);
        }
      })); // Always preserve the current name

      extension.name = this.name; // Set the parent to be our parent

      extension.parent = this.parent;
      return extension;
    }
  }, {
    key: "extend",
    value: function extend() {
      var extendedConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var extension = new Extension(_objectSpread(_objectSpread({}, this.config), extendedConfig));
      extension.parent = this;
      this.child = extension;
      extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;

      if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
        console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(extension.name, "\"."));
      }

      extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
        name: extension.name
      }));
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }], [{
    key: "create",
    value: function create() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Extension(config);
    }
  }]);

  return Extension;
}();
/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */


function getTextBetween(startNode, range, options) {
  var from = range.from,
      to = range.to;

  var _ref24 = options || {},
      _ref24$blockSeparator = _ref24.blockSeparator,
      blockSeparator = _ref24$blockSeparator === void 0 ? '\n\n' : _ref24$blockSeparator,
      _ref24$textSerializer = _ref24.textSerializers,
      textSerializers = _ref24$textSerializer === void 0 ? {} : _ref24$textSerializer;

  var text = '';
  startNode.nodesBetween(from, to, function (node, pos, parent, index) {
    var _a;

    if (node.isBlock && pos > from) {
      text += blockSeparator;
    }

    var textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];

    if (textSerializer) {
      if (parent) {
        text += textSerializer({
          node: node,
          pos: pos,
          parent: parent,
          index: index,
          range: range
        });
      } // do not descend into child nodes when there exists a serializer


      return false;
    }

    if (node.isText) {
      text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
    }
  });
  return text;
}
/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */


function getTextSerializersFromSchema(schema) {
  return Object.fromEntries(Object.entries(schema.nodes).filter(function (_ref25) {
    var _ref26 = _slicedToArray(_ref25, 2),
        node = _ref26[1];

    return node.spec.toText;
  }).map(function (_ref27) {
    var _ref28 = _slicedToArray(_ref27, 2),
        name = _ref28[0],
        node = _ref28[1];

    return [name, node.spec.toText];
  }));
}

var ClipboardTextSerializer = Extension.create({
  name: 'clipboardTextSerializer',
  addOptions: function addOptions() {
    return {
      blockSeparator: undefined
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this16 = this;

    return [new Plugin({
      key: new PluginKey('clipboardTextSerializer'),
      props: {
        clipboardTextSerializer: function clipboardTextSerializer() {
          var editor = _this16.editor;
          var state = editor.state,
              schema = editor.schema;
          var doc = state.doc,
              selection = state.selection;
          var ranges = selection.ranges;
          var from = Math.min.apply(Math, _toConsumableArray(ranges.map(function (range) {
            return range.$from.pos;
          })));
          var to = Math.max.apply(Math, _toConsumableArray(ranges.map(function (range) {
            return range.$to.pos;
          })));
          var textSerializers = getTextSerializersFromSchema(schema);
          var range = {
            from: from,
            to: to
          };
          return getTextBetween(doc, range, _objectSpread(_objectSpread({}, _this16.options.blockSeparator !== undefined ? {
            blockSeparator: _this16.options.blockSeparator
          } : {}), {}, {
            textSerializers: textSerializers
          }));
        }
      }
    })];
  }
});

var blur = function blur() {
  return function (_ref29) {
    var editor = _ref29.editor,
        view = _ref29.view;
    requestAnimationFrame(function () {
      var _a;

      if (!editor.isDestroyed) {
        view.dom.blur(); // Browsers should remove the caret on blur but safari does not.
        // See: https://github.com/ueberdosis/tiptap/issues/2405

        (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
      }
    });
    return true;
  };
};

var clearContent = function clearContent() {
  var emitUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (_ref30) {
    var commands = _ref30.commands;
    return commands.setContent('', emitUpdate);
  };
};

var clearNodes = function clearNodes() {
  return function (_ref31) {
    var state = _ref31.state,
        tr = _ref31.tr,
        dispatch = _ref31.dispatch;
    var selection = tr.selection;
    var ranges = selection.ranges;

    if (!dispatch) {
      return true;
    }

    ranges.forEach(function (_ref32) {
      var $from = _ref32.$from,
          $to = _ref32.$to;
      state.doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
        if (node.type.isText) {
          return;
        }

        var doc = tr.doc,
            mapping = tr.mapping;
        var $mappedFrom = doc.resolve(mapping.map(pos));
        var $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
        var nodeRange = $mappedFrom.blockRange($mappedTo);

        if (!nodeRange) {
          return;
        }

        var targetLiftDepth = liftTarget(nodeRange);

        if (node.type.isTextblock) {
          var _$mappedFrom$parent$c = $mappedFrom.parent.contentMatchAt($mappedFrom.index()),
              defaultType = _$mappedFrom$parent$c.defaultType;

          tr.setNodeMarkup(nodeRange.start, defaultType);
        }

        if (targetLiftDepth || targetLiftDepth === 0) {
          tr.lift(nodeRange, targetLiftDepth);
        }
      });
    });
    return true;
  };
};

var command = function command(fn) {
  return function (props) {
    return fn(props);
  };
};

var createParagraphNear = function createParagraphNear() {
  return function (_ref33) {
    var state = _ref33.state,
        dispatch = _ref33.dispatch;
    return createParagraphNear$1(state, dispatch);
  };
};

var cut = function cut(originRange, targetPos) {
  return function (_ref34) {
    var editor = _ref34.editor,
        tr = _ref34.tr;
    var state = editor.state;
    var contentSlice = state.doc.slice(originRange.from, originRange.to);
    tr.deleteRange(originRange.from, originRange.to);
    var newPos = tr.mapping.map(targetPos);
    tr.insert(newPos, contentSlice.content);
    tr.setSelection(new TextSelection(tr.doc.resolve(newPos - 1)));
    return true;
  };
};

var deleteCurrentNode = function deleteCurrentNode() {
  return function (_ref35) {
    var tr = _ref35.tr,
        dispatch = _ref35.dispatch;
    var selection = tr.selection;
    var currentNode = selection.$anchor.node(); // if there is content inside the current node, break out of this command

    if (currentNode.content.size > 0) {
      return false;
    }

    var $pos = tr.selection.$anchor;

    for (var depth = $pos.depth; depth > 0; depth -= 1) {
      var node = $pos.node(depth);

      if (node.type === currentNode.type) {
        if (dispatch) {
          var from = $pos.before(depth);
          var to = $pos.after(depth);
          tr.delete(from, to).scrollIntoView();
        }

        return true;
      }
    }

    return false;
  };
};

var deleteNode = function deleteNode(typeOrName) {
  return function (_ref36) {
    var tr = _ref36.tr,
        state = _ref36.state,
        dispatch = _ref36.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    var $pos = tr.selection.$anchor;

    for (var depth = $pos.depth; depth > 0; depth -= 1) {
      var node = $pos.node(depth);

      if (node.type === type) {
        if (dispatch) {
          var from = $pos.before(depth);
          var to = $pos.after(depth);
          tr.delete(from, to).scrollIntoView();
        }

        return true;
      }
    }

    return false;
  };
};

var deleteRange = function deleteRange(range) {
  return function (_ref37) {
    var tr = _ref37.tr,
        dispatch = _ref37.dispatch;
    var from = range.from,
        to = range.to;

    if (dispatch) {
      tr.delete(from, to);
    }

    return true;
  };
};

var deleteSelection = function deleteSelection() {
  return function (_ref38) {
    var state = _ref38.state,
        dispatch = _ref38.dispatch;
    return deleteSelection$1(state, dispatch);
  };
};

var enter = function enter() {
  return function (_ref39) {
    var commands = _ref39.commands;
    return commands.keyboardShortcut('Enter');
  };
};

var exitCode = function exitCode() {
  return function (_ref40) {
    var state = _ref40.state,
        dispatch = _ref40.dispatch;
    return exitCode$1(state, dispatch);
  };
};
/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */


function objectIncludes(object1, object2) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    strict: true
  };
  var keys = Object.keys(object2);

  if (!keys.length) {
    return true;
  }

  return keys.every(function (key) {
    if (options.strict) {
      return object2[key] === object1[key];
    }

    if (isRegExp(object2[key])) {
      return object2[key].test(object1[key]);
    }

    return object2[key] === object1[key];
  });
}

function findMarkInSet(marks, type) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return marks.find(function (item) {
    return item.type === type && objectIncludes( // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(attributes).map(function (k) {
      return [k, item.attrs[k]];
    })), attributes);
  });
}

function isMarkInSet(marks, type) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return !!findMarkInSet(marks, type, attributes);
}
/**
 * Get the range of a mark at a resolved position.
 */


function getMarkRange(
/**
 * The position to get the mark range for.
 */
$pos,
/**
 * The mark type to get the range for.
 */
type,
/**
 * The attributes to match against.
 * If not provided, only the first mark at the position will be matched.
 */
attributes) {
  var _a;

  if (!$pos || !type) {
    return;
  }

  var start = $pos.parent.childAfter($pos.parentOffset); // If the cursor is at the start of a text node that does not have the mark, look backward

  if (!start.node || !start.node.marks.some(function (mark) {
    return mark.type === type;
  })) {
    start = $pos.parent.childBefore($pos.parentOffset);
  } // If there is no text node with the mark even backward, return undefined


  if (!start.node || !start.node.marks.some(function (mark) {
    return mark.type === type;
  })) {
    return;
  } // Default to only matching against the first mark's attributes


  attributes = attributes || ((_a = start.node.marks[0]) === null || _a === void 0 ? void 0 : _a.attrs); // We now know that the cursor is either at the start, middle or end of a text node with the specified mark
  // so we can look it up on the targeted mark

  var mark = findMarkInSet(_toConsumableArray(start.node.marks), type, attributes);

  if (!mark) {
    return;
  }

  var startIndex = start.index;
  var startPos = $pos.start() + start.offset;
  var endIndex = startIndex + 1;
  var endPos = startPos + start.node.nodeSize;

  while (startIndex > 0 && isMarkInSet(_toConsumableArray($pos.parent.child(startIndex - 1).marks), type, attributes)) {
    startIndex -= 1;
    startPos -= $pos.parent.child(startIndex).nodeSize;
  }

  while (endIndex < $pos.parent.childCount && isMarkInSet(_toConsumableArray($pos.parent.child(endIndex).marks), type, attributes)) {
    endPos += $pos.parent.child(endIndex).nodeSize;
    endIndex += 1;
  }

  return {
    from: startPos,
    to: endPos
  };
}

function getMarkType(nameOrType, schema) {
  if (typeof nameOrType === 'string') {
    if (!schema.marks[nameOrType]) {
      throw Error("There is no mark type named '".concat(nameOrType, "'. Maybe you forgot to add the extension?"));
    }

    return schema.marks[nameOrType];
  }

  return nameOrType;
}

var extendMarkRange = function extendMarkRange(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref41) {
    var tr = _ref41.tr,
        state = _ref41.state,
        dispatch = _ref41.dispatch;
    var type = getMarkType(typeOrName, state.schema);
    var doc = tr.doc,
        selection = tr.selection;
    var $from = selection.$from,
        from = selection.from,
        to = selection.to;

    if (dispatch) {
      var range = getMarkRange($from, type, attributes);

      if (range && range.from <= from && range.to >= to) {
        var newSelection = TextSelection.create(doc, range.from, range.to);
        tr.setSelection(newSelection);
      }
    }

    return true;
  };
};

var first = function first(commands) {
  return function (props) {
    var items = typeof commands === 'function' ? commands(props) : commands;

    for (var i = 0; i < items.length; i += 1) {
      if (items[i](props)) {
        return true;
      }
    }

    return false;
  };
};

function isTextSelection(value) {
  return value instanceof TextSelection;
}

function minMax() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Math.min(Math.max(value, min), max);
}

function resolveFocusPosition(doc) {
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!position) {
    return null;
  }

  var selectionAtStart = Selection.atStart(doc);
  var selectionAtEnd = Selection.atEnd(doc);

  if (position === 'start' || position === true) {
    return selectionAtStart;
  }

  if (position === 'end') {
    return selectionAtEnd;
  }

  var minPos = selectionAtStart.from;
  var maxPos = selectionAtEnd.to;

  if (position === 'all') {
    return TextSelection.create(doc, minMax(0, minPos, maxPos), minMax(doc.content.size, minPos, maxPos));
  }

  return TextSelection.create(doc, minMax(position, minPos, maxPos), minMax(position, minPos, maxPos));
}

function isAndroid() {
  return navigator.platform === 'Android' || /android/i.test(navigator.userAgent);
}

function isiOS() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) // iPad on iOS 13 detection
  || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
}

var focus = function focus() {
  var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref42) {
    var editor = _ref42.editor,
        view = _ref42.view,
        tr = _ref42.tr,
        dispatch = _ref42.dispatch;
    options = _objectSpread({
      scrollIntoView: true
    }, options);

    var delayedFocus = function delayedFocus() {
      // focus within `requestAnimationFrame` breaks focus on iOS and Android
      // so we have to call this
      if (isiOS() || isAndroid()) {
        view.dom.focus();
      } // For React we have to focus asynchronously. Otherwise wild things happen.
      // see: https://github.com/ueberdosis/tiptap/issues/1520


      requestAnimationFrame(function () {
        if (!editor.isDestroyed) {
          view.focus();

          if (options === null || options === void 0 ? void 0 : options.scrollIntoView) {
            editor.commands.scrollIntoView();
          }
        }
      });
    };

    if (view.hasFocus() && position === null || position === false) {
      return true;
    } // we don’t try to resolve a NodeSelection or CellSelection


    if (dispatch && position === null && !isTextSelection(editor.state.selection)) {
      delayedFocus();
      return true;
    } // pass through tr.doc instead of editor.state.doc
    // since transactions could change the editors state before this command has been run


    var selection = resolveFocusPosition(tr.doc, position) || editor.state.selection;
    var isSameSelection = editor.state.selection.eq(selection);

    if (dispatch) {
      if (!isSameSelection) {
        tr.setSelection(selection);
      } // `tr.setSelection` resets the stored marks
      // so we’ll restore them if the selection is the same as before


      if (isSameSelection && tr.storedMarks) {
        tr.setStoredMarks(tr.storedMarks);
      }

      delayedFocus();
    }

    return true;
  };
};

var forEach = function forEach(items, fn) {
  return function (props) {
    return items.every(function (item, index) {
      return fn(item, _objectSpread(_objectSpread({}, props), {}, {
        index: index
      }));
    });
  };
};

var insertContent = function insertContent(value, options) {
  return function (_ref43) {
    var tr = _ref43.tr,
        commands = _ref43.commands;
    return commands.insertContentAt({
      from: tr.selection.from,
      to: tr.selection.to
    }, value, options);
  };
};

var removeWhitespaces = function removeWhitespaces(node) {
  var children = node.childNodes;

  for (var i = children.length - 1; i >= 0; i -= 1) {
    var child = children[i];

    if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) {
      node.removeChild(child);
    } else if (child.nodeType === 1) {
      removeWhitespaces(child);
    }
  }

  return node;
};

function elementFromString(value) {
  // add a wrapper to preserve leading and trailing whitespace
  var wrappedValue = "<body>".concat(value, "</body>");
  var html = new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
  return removeWhitespaces(html);
}
/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */


function createNodeFromContent(content, schema, options) {
  if (content instanceof Node$1 || content instanceof Fragment) {
    return content;
  }

  options = _objectSpread({
    slice: true,
    parseOptions: {}
  }, options);
  var isJSONContent = _typeof(content) === 'object' && content !== null;
  var isTextContent = typeof content === 'string';

  if (isJSONContent) {
    try {
      var isArrayContent = Array.isArray(content) && content.length > 0; // if the JSON Content is an array of nodes, create a fragment for each node

      if (isArrayContent) {
        return Fragment.fromArray(content.map(function (item) {
          return schema.nodeFromJSON(item);
        }));
      }

      var node = schema.nodeFromJSON(content);

      if (options.errorOnInvalidContent) {
        node.check();
      }

      return node;
    } catch (error) {
      if (options.errorOnInvalidContent) {
        throw new Error('[tiptap error]: Invalid JSON content', {
          cause: error
        });
      }

      console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
      return createNodeFromContent('', schema, options);
    }
  }

  if (isTextContent) {
    // Check for invalid content
    if (options.errorOnInvalidContent) {
      var hasInvalidContent = false;
      var invalidContent = ''; // A copy of the current schema with a catch-all node at the end

      var contentCheckSchema = new Schema({
        topNode: schema.spec.topNode,
        marks: schema.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: schema.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: 'inline*',
            group: 'block',
            parseDOM: [{
              tag: '*',
              getAttrs: function getAttrs(e) {
                // If this is ever called, we know that the content has something that we don't know how to handle in the schema
                hasInvalidContent = true; // Try to stringify the element for a more helpful error message

                invalidContent = typeof e === 'string' ? e : e.outerHTML;
                return null;
              }
            }]
          }
        })
      });

      if (options.slice) {
        DOMParser.fromSchema(contentCheckSchema).parseSlice(elementFromString(content), options.parseOptions);
      } else {
        DOMParser.fromSchema(contentCheckSchema).parse(elementFromString(content), options.parseOptions);
      }

      if (options.errorOnInvalidContent && hasInvalidContent) {
        throw new Error('[tiptap error]: Invalid HTML content', {
          cause: new Error("Invalid element found: ".concat(invalidContent))
        });
      }
    }

    var parser = DOMParser.fromSchema(schema);

    if (options.slice) {
      return parser.parseSlice(elementFromString(content), options.parseOptions).content;
    }

    return parser.parse(elementFromString(content), options.parseOptions);
  }

  return createNodeFromContent('', schema, options);
} // source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466


function selectionToInsertionEnd(tr, startLen, bias) {
  var last = tr.steps.length - 1;

  if (last < startLen) {
    return;
  }

  var step = tr.steps[last];

  if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep)) {
    return;
  }

  var map = tr.mapping.maps[last];
  var end = 0;
  map.forEach(function (_from, _to, _newFrom, newTo) {
    if (end === 0) {
      end = newTo;
    }
  });
  tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

var isFragment = function isFragment(nodeOrFragment) {
  return !('type' in nodeOrFragment);
};

var insertContentAt = function insertContentAt(position, value, options) {
  return function (_ref44) {
    var tr = _ref44.tr,
        dispatch = _ref44.dispatch,
        editor = _ref44.editor;

    var _a;

    if (dispatch) {
      options = _objectSpread({
        parseOptions: editor.options.parseOptions,
        updateSelection: true,
        applyInputRules: false,
        applyPasteRules: false
      }, options);
      var content;

      try {
        content = createNodeFromContent(value, editor.schema, {
          parseOptions: _objectSpread({
            preserveWhitespace: 'full'
          }, options.parseOptions),
          errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
        });
      } catch (e) {
        editor.emit('contentError', {
          editor: editor,
          error: e,
          disableCollaboration: function disableCollaboration() {
            if (editor.storage.collaboration) {
              editor.storage.collaboration.isDisabled = true;
            }
          }
        });
        return false;
      }

      var _ref45 = typeof position === 'number' ? {
        from: position,
        to: position
      } : {
        from: position.from,
        to: position.to
      },
          from = _ref45.from,
          to = _ref45.to;

      var isOnlyTextContent = true;
      var isOnlyBlockContent = true;
      var nodes = isFragment(content) ? content : [content];
      nodes.forEach(function (node) {
        // check if added node is valid
        node.check();
        isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
        isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
      }); // check if we can replace the wrapping node by
      // the newly inserted content
      // example:
      // replace an empty paragraph by an inserted image
      // instead of inserting the image below the paragraph

      if (from === to && isOnlyBlockContent) {
        var _tr$doc$resolve = tr.doc.resolve(from),
            parent = _tr$doc$resolve.parent;

        var isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;

        if (isEmptyTextBlock) {
          from -= 1;
          to += 1;
        }
      }

      var newContent; // if there is only plain text we have to use `insertText`
      // because this will keep the current marks

      if (isOnlyTextContent) {
        // if value is string, we can use it directly
        // otherwise if it is an array, we have to join it
        if (Array.isArray(value)) {
          newContent = value.map(function (v) {
            return v.text || '';
          }).join('');
        } else if (value instanceof Fragment) {
          var text = '';
          value.forEach(function (node) {
            if (node.text) {
              text += node.text;
            }
          });
          newContent = text;
        } else if (_typeof(value) === 'object' && !!value && !!value.text) {
          newContent = value.text;
        } else {
          newContent = value;
        }

        tr.insertText(newContent, from, to);
      } else {
        newContent = content;
        tr.replaceWith(from, to, newContent);
      } // set cursor at end of inserted content


      if (options.updateSelection) {
        selectionToInsertionEnd(tr, tr.steps.length - 1, -1);
      }

      if (options.applyInputRules) {
        tr.setMeta('applyInputRules', {
          from: from,
          text: newContent
        });
      }

      if (options.applyPasteRules) {
        tr.setMeta('applyPasteRules', {
          from: from,
          text: newContent
        });
      }
    }

    return true;
  };
};

var joinUp = function joinUp() {
  return function (_ref46) {
    var state = _ref46.state,
        dispatch = _ref46.dispatch;
    return joinUp$1(state, dispatch);
  };
};

var joinDown = function joinDown() {
  return function (_ref47) {
    var state = _ref47.state,
        dispatch = _ref47.dispatch;
    return joinDown$1(state, dispatch);
  };
};

var joinBackward = function joinBackward() {
  return function (_ref48) {
    var state = _ref48.state,
        dispatch = _ref48.dispatch;
    return joinBackward$1(state, dispatch);
  };
};

var joinForward = function joinForward() {
  return function (_ref49) {
    var state = _ref49.state,
        dispatch = _ref49.dispatch;
    return joinForward$1(state, dispatch);
  };
};

var joinItemBackward = function joinItemBackward() {
  return function (_ref50) {
    var state = _ref50.state,
        dispatch = _ref50.dispatch,
        tr = _ref50.tr;

    try {
      var point = joinPoint(state.doc, state.selection.$from.pos, -1);

      if (point === null || point === undefined) {
        return false;
      }

      tr.join(point, 2);

      if (dispatch) {
        dispatch(tr);
      }

      return true;
    } catch (_unused3) {
      return false;
    }
  };
};

var joinItemForward = function joinItemForward() {
  return function (_ref51) {
    var state = _ref51.state,
        dispatch = _ref51.dispatch,
        tr = _ref51.tr;

    try {
      var point = joinPoint(state.doc, state.selection.$from.pos, +1);

      if (point === null || point === undefined) {
        return false;
      }

      tr.join(point, 2);

      if (dispatch) {
        dispatch(tr);
      }

      return true;
    } catch (_unused4) {
      return false;
    }
  };
};

var joinTextblockBackward = function joinTextblockBackward() {
  return function (_ref52) {
    var state = _ref52.state,
        dispatch = _ref52.dispatch;
    return joinTextblockBackward$1(state, dispatch);
  };
};

var joinTextblockForward = function joinTextblockForward() {
  return function (_ref53) {
    var state = _ref53.state,
        dispatch = _ref53.dispatch;
    return joinTextblockForward$1(state, dispatch);
  };
};

function isMacOS() {
  return typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
}

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/);
  var result = parts[parts.length - 1];

  if (result === 'Space') {
    result = ' ';
  }

  var alt;
  var ctrl;
  var shift;
  var meta;

  for (var i = 0; i < parts.length - 1; i += 1) {
    var mod = parts[i];

    if (/^(cmd|meta|m)$/i.test(mod)) {
      meta = true;
    } else if (/^a(lt)?$/i.test(mod)) {
      alt = true;
    } else if (/^(c|ctrl|control)$/i.test(mod)) {
      ctrl = true;
    } else if (/^s(hift)?$/i.test(mod)) {
      shift = true;
    } else if (/^mod$/i.test(mod)) {
      if (isiOS() || isMacOS()) {
        meta = true;
      } else {
        ctrl = true;
      }
    } else {
      throw new Error("Unrecognized modifier name: ".concat(mod));
    }
  }

  if (alt) {
    result = "Alt-".concat(result);
  }

  if (ctrl) {
    result = "Ctrl-".concat(result);
  }

  if (meta) {
    result = "Meta-".concat(result);
  }

  if (shift) {
    result = "Shift-".concat(result);
  }

  return result;
}

var keyboardShortcut = function keyboardShortcut(name) {
  return function (_ref54) {
    var editor = _ref54.editor,
        view = _ref54.view,
        tr = _ref54.tr,
        dispatch = _ref54.dispatch;
    var keys = normalizeKeyName(name).split(/-(?!$)/);
    var key = keys.find(function (item) {
      return !['Alt', 'Ctrl', 'Meta', 'Shift'].includes(item);
    });
    var event = new KeyboardEvent('keydown', {
      key: key === 'Space' ? ' ' : key,
      altKey: keys.includes('Alt'),
      ctrlKey: keys.includes('Ctrl'),
      metaKey: keys.includes('Meta'),
      shiftKey: keys.includes('Shift'),
      bubbles: true,
      cancelable: true
    });
    var capturedTransaction = editor.captureTransaction(function () {
      view.someProp('handleKeyDown', function (f) {
        return f(view, event);
      });
    });
    capturedTransaction === null || capturedTransaction === void 0 ? void 0 : capturedTransaction.steps.forEach(function (step) {
      var newStep = step.map(tr.mapping);

      if (newStep && dispatch) {
        tr.maybeStep(newStep);
      }
    });
    return true;
  };
};

function isNodeActive(state, typeOrName) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _state$selection = state.selection,
      from = _state$selection.from,
      to = _state$selection.to,
      empty = _state$selection.empty;
  var type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
  var nodeRanges = [];
  state.doc.nodesBetween(from, to, function (node, pos) {
    if (node.isText) {
      return;
    }

    var relativeFrom = Math.max(from, pos);
    var relativeTo = Math.min(to, pos + node.nodeSize);
    nodeRanges.push({
      node: node,
      from: relativeFrom,
      to: relativeTo
    });
  });
  var selectionRange = to - from;
  var matchedNodeRanges = nodeRanges.filter(function (nodeRange) {
    if (!type) {
      return true;
    }

    return type.name === nodeRange.node.type.name;
  }).filter(function (nodeRange) {
    return objectIncludes(nodeRange.node.attrs, attributes, {
      strict: false
    });
  });

  if (empty) {
    return !!matchedNodeRanges.length;
  }

  var range = matchedNodeRanges.reduce(function (sum, nodeRange) {
    return sum + nodeRange.to - nodeRange.from;
  }, 0);
  return range >= selectionRange;
}

var lift = function lift(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref55) {
    var state = _ref55.state,
        dispatch = _ref55.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    var isActive = isNodeActive(state, type, attributes);

    if (!isActive) {
      return false;
    }

    return lift$1(state, dispatch);
  };
};

var liftEmptyBlock = function liftEmptyBlock() {
  return function (_ref56) {
    var state = _ref56.state,
        dispatch = _ref56.dispatch;
    return liftEmptyBlock$1(state, dispatch);
  };
};

var liftListItem = function liftListItem(typeOrName) {
  return function (_ref57) {
    var state = _ref57.state,
        dispatch = _ref57.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    return liftListItem$1(type)(state, dispatch);
  };
};

var newlineInCode = function newlineInCode() {
  return function (_ref58) {
    var state = _ref58.state,
        dispatch = _ref58.dispatch;
    return newlineInCode$1(state, dispatch);
  };
};
/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */


function getSchemaTypeNameByName(name, schema) {
  if (schema.nodes[name]) {
    return 'node';
  }

  if (schema.marks[name]) {
    return 'mark';
  }

  return null;
}
/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */


function deleteProps(obj, propOrProps) {
  var props = typeof propOrProps === 'string' ? [propOrProps] : propOrProps;
  return Object.keys(obj).reduce(function (newObj, prop) {
    if (!props.includes(prop)) {
      newObj[prop] = obj[prop];
    }

    return newObj;
  }, {});
}

var resetAttributes = function resetAttributes(typeOrName, attributes) {
  return function (_ref59) {
    var tr = _ref59.tr,
        state = _ref59.state,
        dispatch = _ref59.dispatch;
    var nodeType = null;
    var markType = null;
    var schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);

    if (!schemaType) {
      return false;
    }

    if (schemaType === 'node') {
      nodeType = getNodeType(typeOrName, state.schema);
    }

    if (schemaType === 'mark') {
      markType = getMarkType(typeOrName, state.schema);
    }

    if (dispatch) {
      tr.selection.ranges.forEach(function (range) {
        state.doc.nodesBetween(range.$from.pos, range.$to.pos, function (node, pos) {
          if (nodeType && nodeType === node.type) {
            tr.setNodeMarkup(pos, undefined, deleteProps(node.attrs, attributes));
          }

          if (markType && node.marks.length) {
            node.marks.forEach(function (mark) {
              if (markType === mark.type) {
                tr.addMark(pos, pos + node.nodeSize, markType.create(deleteProps(mark.attrs, attributes)));
              }
            });
          }
        });
      });
    }

    return true;
  };
};

var scrollIntoView = function scrollIntoView() {
  return function (_ref60) {
    var tr = _ref60.tr,
        dispatch = _ref60.dispatch;

    if (dispatch) {
      tr.scrollIntoView();
    }

    return true;
  };
};

var selectAll = function selectAll() {
  return function (_ref61) {
    var tr = _ref61.tr,
        dispatch = _ref61.dispatch;

    if (dispatch) {
      var selection = new AllSelection(tr.doc);
      tr.setSelection(selection);
    }

    return true;
  };
};

var selectNodeBackward = function selectNodeBackward() {
  return function (_ref62) {
    var state = _ref62.state,
        dispatch = _ref62.dispatch;
    return selectNodeBackward$1(state, dispatch);
  };
};

var selectNodeForward = function selectNodeForward() {
  return function (_ref63) {
    var state = _ref63.state,
        dispatch = _ref63.dispatch;
    return selectNodeForward$1(state, dispatch);
  };
};

var selectParentNode = function selectParentNode() {
  return function (_ref64) {
    var state = _ref64.state,
        dispatch = _ref64.dispatch;
    return selectParentNode$1(state, dispatch);
  };
}; // @ts-ignore
// TODO: add types to @types/prosemirror-commands


var selectTextblockEnd = function selectTextblockEnd() {
  return function (_ref65) {
    var state = _ref65.state,
        dispatch = _ref65.dispatch;
    return selectTextblockEnd$1(state, dispatch);
  };
}; // @ts-ignore
// TODO: add types to @types/prosemirror-commands


var selectTextblockStart = function selectTextblockStart() {
  return function (_ref66) {
    var state = _ref66.state,
        dispatch = _ref66.dispatch;
    return selectTextblockStart$1(state, dispatch);
  };
};
/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */


function createDocument(content, schema) {
  var parseOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return createNodeFromContent(content, schema, {
    slice: false,
    parseOptions: parseOptions,
    errorOnInvalidContent: options.errorOnInvalidContent
  });
}

var setContent = function setContent(content) {
  var emitUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var parseOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (_ref67) {
    var editor = _ref67.editor,
        tr = _ref67.tr,
        dispatch = _ref67.dispatch,
        commands = _ref67.commands;

    var _a, _b;

    var doc = tr.doc; // This is to keep backward compatibility with the previous behavior
    // TODO remove this in the next major version

    if (parseOptions.preserveWhitespace !== 'full') {
      var _document = createDocument(content, editor.schema, parseOptions, {
        errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
      });

      if (dispatch) {
        tr.replaceWith(0, doc.content.size, _document).setMeta('preventUpdate', !emitUpdate);
      }

      return true;
    }

    if (dispatch) {
      tr.setMeta('preventUpdate', !emitUpdate);
    }

    return commands.insertContentAt({
      from: 0,
      to: doc.content.size
    }, content, {
      parseOptions: parseOptions,
      errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck
    });
  };
};

function getMarkAttributes(state, typeOrName) {
  var type = getMarkType(typeOrName, state.schema);
  var _state$selection2 = state.selection,
      from = _state$selection2.from,
      to = _state$selection2.to,
      empty = _state$selection2.empty;
  var marks = [];

  if (empty) {
    if (state.storedMarks) {
      marks.push.apply(marks, _toConsumableArray(state.storedMarks));
    }

    marks.push.apply(marks, _toConsumableArray(state.selection.$head.marks()));
  } else {
    state.doc.nodesBetween(from, to, function (node) {
      marks.push.apply(marks, _toConsumableArray(node.marks));
    });
  }

  var mark = marks.find(function (markItem) {
    return markItem.type.name === type.name;
  });

  if (!mark) {
    return {};
  }

  return _objectSpread({}, mark.attrs);
}
/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */


function combineTransactionSteps(oldDoc, transactions) {
  var transform = new Transform(oldDoc);
  transactions.forEach(function (transaction) {
    transaction.steps.forEach(function (step) {
      transform.step(step);
    });
  });
  return transform;
}
/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */


function defaultBlockAt(match) {
  for (var i = 0; i < match.edgeCount; i += 1) {
    var _match$edge = match.edge(i),
        type = _match$edge.type;

    if (type.isTextblock && !type.hasRequiredAttrs()) {
      return type;
    }
  }

  return null;
}
/**
 * Find children inside a Prosemirror node that match a predicate.
 * @param node The Prosemirror node to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */


function findChildren(node, predicate) {
  var nodesWithPos = [];
  node.descendants(function (child, pos) {
    if (predicate(child)) {
      nodesWithPos.push({
        node: child,
        pos: pos
      });
    }
  });
  return nodesWithPos;
}
/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */


function findChildrenInRange(node, range, predicate) {
  var nodesWithPos = []; // if (range.from === range.to) {
  //   const nodeAt = node.nodeAt(range.from)
  //   if (nodeAt) {
  //     nodesWithPos.push({
  //       node: nodeAt,
  //       pos: range.from,
  //     })
  //   }
  // }

  node.nodesBetween(range.from, range.to, function (child, pos) {
    if (predicate(child)) {
      nodesWithPos.push({
        node: child,
        pos: pos
      });
    }
  });
  return nodesWithPos;
}
/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */


function findParentNodeClosestToPos($pos, predicate) {
  for (var i = $pos.depth; i > 0; i -= 1) {
    var node = $pos.node(i);

    if (predicate(node)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node: node
      };
    }
  }
}
/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */


function findParentNode(predicate) {
  return function (selection) {
    return findParentNodeClosestToPos(selection.$from, predicate);
  };
}

function getSchema(extensions, editor) {
  var resolvedExtensions = ExtensionManager.resolve(extensions);
  return getSchemaByResolvedExtensions(resolvedExtensions, editor);
}
/**
 * Generate HTML from a JSONContent
 * @param doc The JSONContent to generate HTML from
 * @param extensions The extensions to use for the schema
 * @returns The generated HTML
 */


function generateHTML(doc, extensions) {
  var schema = getSchema(extensions);
  var contentNode = Node$1.fromJSON(schema, doc);
  return getHTMLFromFragment(contentNode.content, schema);
}
/**
 * Generate JSONContent from HTML
 * @param html The HTML to generate JSONContent from
 * @param extensions The extensions to use for the schema
 * @returns The generated JSONContent
 */


function generateJSON(html, extensions) {
  var schema = getSchema(extensions);
  var dom = elementFromString(html);
  return DOMParser.fromSchema(schema).parse(dom).toJSON();
}
/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */


function _getText(node, options) {
  var range = {
    from: 0,
    to: node.content.size
  };
  return getTextBetween(node, range, options);
}
/**
 * Generate raw text from a JSONContent
 * @param doc The JSONContent to generate text from
 * @param extensions The extensions to use for the schema
 * @param options Options for the text generation f.e. blockSeparator or textSerializers
 * @returns The generated text
 */


function generateText(doc, extensions, options) {
  var _ref68 = options || {},
      _ref68$blockSeparator = _ref68.blockSeparator,
      blockSeparator = _ref68$blockSeparator === void 0 ? '\n\n' : _ref68$blockSeparator,
      _ref68$textSerializer = _ref68.textSerializers,
      textSerializers = _ref68$textSerializer === void 0 ? {} : _ref68$textSerializer;

  var schema = getSchema(extensions);
  var contentNode = Node$1.fromJSON(schema, doc);
  return _getText(contentNode, {
    blockSeparator: blockSeparator,
    textSerializers: _objectSpread(_objectSpread({}, getTextSerializersFromSchema(schema)), textSerializers)
  });
}

function getNodeAttributes(state, typeOrName) {
  var type = getNodeType(typeOrName, state.schema);
  var _state$selection3 = state.selection,
      from = _state$selection3.from,
      to = _state$selection3.to;
  var nodes = [];
  state.doc.nodesBetween(from, to, function (node) {
    nodes.push(node);
  });
  var node = nodes.reverse().find(function (nodeItem) {
    return nodeItem.type.name === type.name;
  });

  if (!node) {
    return {};
  }

  return _objectSpread({}, node.attrs);
}
/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */


function _getAttributes(state, typeOrName) {
  var schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);

  if (schemaType === 'node') {
    return getNodeAttributes(state, typeOrName);
  }

  if (schemaType === 'mark') {
    return getMarkAttributes(state, typeOrName);
  }

  return {};
}
/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */


function removeDuplicates(array) {
  var by = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : JSON.stringify;
  var seen = {};
  return array.filter(function (item) {
    var key = by(item);
    return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
  });
}
/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */


function simplifyChangedRanges(changes) {
  var uniqueChanges = removeDuplicates(changes);
  return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter(function (change, index) {
    var rest = uniqueChanges.filter(function (_, i) {
      return i !== index;
    });
    return !rest.some(function (otherChange) {
      return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
    });
  });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */


function getChangedRanges(transform) {
  var mapping = transform.mapping,
      steps = transform.steps;
  var changes = [];
  mapping.maps.forEach(function (stepMap, index) {
    var ranges = []; // This accounts for step changes where no range was actually altered
    // e.g. when setting a mark, node attribute, etc.
    // @ts-ignore

    if (!stepMap.ranges.length) {
      var _steps$index = steps[index],
          from = _steps$index.from,
          to = _steps$index.to;

      if (from === undefined || to === undefined) {
        return;
      }

      ranges.push({
        from: from,
        to: to
      });
    } else {
      stepMap.forEach(function (from, to) {
        ranges.push({
          from: from,
          to: to
        });
      });
    }

    ranges.forEach(function (_ref69) {
      var from = _ref69.from,
          to = _ref69.to;
      var newStart = mapping.slice(index).map(from, -1);
      var newEnd = mapping.slice(index).map(to);
      var oldStart = mapping.invert().map(newStart, -1);
      var oldEnd = mapping.invert().map(newEnd);
      changes.push({
        oldRange: {
          from: oldStart,
          to: oldEnd
        },
        newRange: {
          from: newStart,
          to: newEnd
        }
      });
    });
  });
  return simplifyChangedRanges(changes);
}

function getDebugJSON(node) {
  var startOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isTopNode = node.type === node.type.schema.topNodeType;
  var increment = isTopNode ? 0 : 1;
  var from = startOffset;
  var to = from + node.nodeSize;
  var marks = node.marks.map(function (mark) {
    var output = {
      type: mark.type.name
    };

    if (Object.keys(mark.attrs).length) {
      output.attrs = _objectSpread({}, mark.attrs);
    }

    return output;
  });

  var attrs = _objectSpread({}, node.attrs);

  var output = {
    type: node.type.name,
    from: from,
    to: to
  };

  if (Object.keys(attrs).length) {
    output.attrs = attrs;
  }

  if (marks.length) {
    output.marks = marks;
  }

  if (node.content.childCount) {
    output.content = [];
    node.forEach(function (child, offset) {
      var _a;

      (_a = output.content) === null || _a === void 0 ? void 0 : _a.push(getDebugJSON(child, startOffset + offset + increment));
    });
  }

  if (node.text) {
    output.text = node.text;
  }

  return output;
}

function getMarksBetween(from, to, doc) {
  var marks = []; // get all inclusive marks on empty selection

  if (from === to) {
    doc.resolve(from).marks().forEach(function (mark) {
      var $pos = doc.resolve(from);
      var range = getMarkRange($pos, mark.type);

      if (!range) {
        return;
      }

      marks.push(_objectSpread({
        mark: mark
      }, range));
    });
  } else {
    doc.nodesBetween(from, to, function (node, pos) {
      if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) {
        return;
      }

      marks.push.apply(marks, _toConsumableArray(node.marks.map(function (mark) {
        return {
          from: pos,
          to: pos + node.nodeSize,
          mark: mark
        };
      })));
    });
  }

  return marks;
}
/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */


var getNodeAtPosition = function getNodeAtPosition(state, typeOrName, pos) {
  var maxDepth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
  var $pos = state.doc.resolve(pos);
  var currentDepth = maxDepth;
  var node = null;

  while (currentDepth > 0 && node === null) {
    var currentNode = $pos.node(currentDepth);

    if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) {
      node = currentNode;
    } else {
      currentDepth -= 1;
    }
  }

  return [node, currentDepth];
};
/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */


function getSplittedAttributes(extensionAttributes, typeName, attributes) {
  return Object.fromEntries(Object.entries(attributes).filter(function (_ref70) {
    var _ref71 = _slicedToArray(_ref70, 1),
        name = _ref71[0];

    var extensionAttribute = extensionAttributes.find(function (item) {
      return item.type === typeName && item.name === name;
    });

    if (!extensionAttribute) {
      return false;
    }

    return extensionAttribute.attribute.keepOnSplit;
  }));
}

function isMarkActive(state, typeOrName) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _state$selection4 = state.selection,
      empty = _state$selection4.empty,
      ranges = _state$selection4.ranges;
  var type = typeOrName ? getMarkType(typeOrName, state.schema) : null;

  if (empty) {
    return !!(state.storedMarks || state.selection.$from.marks()).filter(function (mark) {
      if (!type) {
        return true;
      }

      return type.name === mark.type.name;
    }).find(function (mark) {
      return objectIncludes(mark.attrs, attributes, {
        strict: false
      });
    });
  }

  var selectionRange = 0;
  var markRanges = [];
  ranges.forEach(function (_ref72) {
    var $from = _ref72.$from,
        $to = _ref72.$to;
    var from = $from.pos;
    var to = $to.pos;
    state.doc.nodesBetween(from, to, function (node, pos) {
      if (!node.isText && !node.marks.length) {
        return;
      }

      var relativeFrom = Math.max(from, pos);
      var relativeTo = Math.min(to, pos + node.nodeSize);
      var range = relativeTo - relativeFrom;
      selectionRange += range;
      markRanges.push.apply(markRanges, _toConsumableArray(node.marks.map(function (mark) {
        return {
          mark: mark,
          from: relativeFrom,
          to: relativeTo
        };
      })));
    });
  });

  if (selectionRange === 0) {
    return false;
  } // calculate range of matched mark


  var matchedRange = markRanges.filter(function (markRange) {
    if (!type) {
      return true;
    }

    return type.name === markRange.mark.type.name;
  }).filter(function (markRange) {
    return objectIncludes(markRange.mark.attrs, attributes, {
      strict: false
    });
  }).reduce(function (sum, markRange) {
    return sum + markRange.to - markRange.from;
  }, 0); // calculate range of marks that excludes the searched mark
  // for example `code` doesn’t allow any other marks

  var excludedRange = markRanges.filter(function (markRange) {
    if (!type) {
      return true;
    }

    return markRange.mark.type !== type && markRange.mark.type.excludes(type);
  }).reduce(function (sum, markRange) {
    return sum + markRange.to - markRange.from;
  }, 0); // we only include the result of `excludedRange`
  // if there is a match at all

  var range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
  return range >= selectionRange;
}

function _isActive(state, name) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!name) {
    return isNodeActive(state, null, attributes) || isMarkActive(state, null, attributes);
  }

  var schemaType = getSchemaTypeNameByName(name, state.schema);

  if (schemaType === 'node') {
    return isNodeActive(state, name, attributes);
  }

  if (schemaType === 'mark') {
    return isMarkActive(state, name, attributes);
  }

  return false;
}

var isAtEndOfNode = function isAtEndOfNode(state, nodeType) {
  var _state$selection5 = state.selection,
      $from = _state$selection5.$from,
      $to = _state$selection5.$to,
      $anchor = _state$selection5.$anchor;

  if (nodeType) {
    var parentNode = findParentNode(function (node) {
      return node.type.name === nodeType;
    })(state.selection);

    if (!parentNode) {
      return false;
    }

    var $parentPos = state.doc.resolve(parentNode.pos + 1);

    if ($anchor.pos + 1 === $parentPos.end()) {
      return true;
    }

    return false;
  }

  if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) {
    return false;
  }

  return true;
};

var isAtStartOfNode = function isAtStartOfNode(state) {
  var _state$selection6 = state.selection,
      $from = _state$selection6.$from,
      $to = _state$selection6.$to;

  if ($from.parentOffset > 0 || $from.pos !== $to.pos) {
    return false;
  }

  return true;
};

function isList(name, extensions) {
  var _splitExtensions4 = splitExtensions(extensions),
      nodeExtensions = _splitExtensions4.nodeExtensions;

  var extension = nodeExtensions.find(function (item) {
    return item.name === name;
  });

  if (!extension) {
    return false;
  }

  var context = {
    name: extension.name,
    options: extension.options,
    storage: extension.storage
  };
  var group = callOrReturn(getExtensionField(extension, 'group', context));

  if (typeof group !== 'string') {
    return false;
  }

  return group.split(' ').includes('list');
}
/**
 * Returns true if the given prosemirror node is empty.
 */


function isNodeEmpty(node) {
  var _ref73 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref73$checkChildren = _ref73.checkChildren,
      checkChildren = _ref73$checkChildren === void 0 ? true : _ref73$checkChildren,
      _ref73$ignoreWhitespa = _ref73.ignoreWhitespace,
      ignoreWhitespace = _ref73$ignoreWhitespa === void 0 ? false : _ref73$ignoreWhitespa;

  var _a;

  if (ignoreWhitespace) {
    if (node.type.name === 'hardBreak') {
      // Hard breaks are considered empty
      return true;
    }

    if (node.isText) {
      return /^\s*$/m.test((_a = node.text) !== null && _a !== void 0 ? _a : '');
    }
  }

  if (node.isText) {
    return !node.text;
  }

  if (node.isAtom || node.isLeaf) {
    return false;
  }

  if (node.content.childCount === 0) {
    return true;
  }

  if (checkChildren) {
    var isContentEmpty = true;
    node.content.forEach(function (childNode) {
      if (isContentEmpty === false) {
        // Exit early for perf
        return;
      }

      if (!isNodeEmpty(childNode, {
        ignoreWhitespace: ignoreWhitespace,
        checkChildren: checkChildren
      })) {
        isContentEmpty = false;
      }
    });
    return isContentEmpty;
  }

  return false;
}

function isNodeSelection(value) {
  return value instanceof NodeSelection;
}

function posToDOMRect(view, from, to) {
  var minPos = 0;
  var maxPos = view.state.doc.content.size;
  var resolvedFrom = minMax(from, minPos, maxPos);
  var resolvedEnd = minMax(to, minPos, maxPos);
  var start = view.coordsAtPos(resolvedFrom);
  var end = view.coordsAtPos(resolvedEnd, -1);
  var top = Math.min(start.top, end.top);
  var bottom = Math.max(start.bottom, end.bottom);
  var left = Math.min(start.left, end.left);
  var right = Math.max(start.right, end.right);
  var width = right - left;
  var height = bottom - top;
  var x = left;
  var y = top;
  var data = {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height,
    x: x,
    y: y
  };
  return _objectSpread(_objectSpread({}, data), {}, {
    toJSON: function toJSON() {
      return data;
    }
  });
}
/**
 * The actual implementation of the rewriteUnknownContent function
 */


function rewriteUnknownContentInner(_ref74) {
  var json = _ref74.json,
      validMarks = _ref74.validMarks,
      validNodes = _ref74.validNodes,
      options = _ref74.options,
      _ref74$rewrittenConte = _ref74.rewrittenContent,
      rewrittenContent = _ref74$rewrittenConte === void 0 ? [] : _ref74$rewrittenConte;

  if (json.marks && Array.isArray(json.marks)) {
    json.marks = json.marks.filter(function (mark) {
      var name = typeof mark === 'string' ? mark : mark.type;

      if (validMarks.has(name)) {
        return true;
      }

      rewrittenContent.push({
        original: JSON.parse(JSON.stringify(mark)),
        unsupported: name
      }); // Just ignore any unknown marks

      return false;
    });
  }

  if (json.content && Array.isArray(json.content)) {
    json.content = json.content.map(function (value) {
      return rewriteUnknownContentInner({
        json: value,
        validMarks: validMarks,
        validNodes: validNodes,
        options: options,
        rewrittenContent: rewrittenContent
      }).json;
    }).filter(function (a) {
      return a !== null && a !== undefined;
    });
  }

  if (json.type && !validNodes.has(json.type)) {
    rewrittenContent.push({
      original: JSON.parse(JSON.stringify(json)),
      unsupported: json.type
    });

    if (json.content && Array.isArray(json.content) && (options === null || options === void 0 ? void 0 : options.fallbackToParagraph) !== false) {
      // Just treat it like a paragraph and hope for the best
      json.type = 'paragraph';
      return {
        json: json,
        rewrittenContent: rewrittenContent
      };
    } // or just omit it entirely


    return {
      json: null,
      rewrittenContent: rewrittenContent
    };
  }

  return {
    json: json,
    rewrittenContent: rewrittenContent
  };
}
/**
 * Rewrite unknown nodes and marks within JSON content
 * Allowing for user within the editor
 */


function rewriteUnknownContent(
/**
 * The JSON content to clean of unknown nodes and marks
 */
json,
/**
 * The schema to use for validation
 */
schema,
/**
 * Options for the cleaning process
 */
options) {
  return rewriteUnknownContentInner({
    json: json,
    validNodes: new Set(Object.keys(schema.nodes)),
    validMarks: new Set(Object.keys(schema.marks)),
    options: options
  });
}

function canSetMark(state, tr, newMarkType) {
  var _a;

  var selection = tr.selection;
  var cursor = null;

  if (isTextSelection(selection)) {
    cursor = selection.$cursor;
  }

  if (cursor) {
    var currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks(); // There can be no current marks that exclude the new mark

    return !!newMarkType.isInSet(currentMarks) || !currentMarks.some(function (mark) {
      return mark.type.excludes(newMarkType);
    });
  }

  var ranges = selection.ranges;
  return ranges.some(function (_ref75) {
    var $from = _ref75.$from,
        $to = _ref75.$to;
    var someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
    state.doc.nodesBetween($from.pos, $to.pos, function (node, _pos, parent) {
      // If we already found a mark that we can enable, return false to bypass the remaining search
      if (someNodeSupportsMark) {
        return false;
      }

      if (node.isInline) {
        var parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
        var currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some(function (otherMark) {
          return otherMark.type.excludes(newMarkType);
        });
        someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
      }

      return !someNodeSupportsMark;
    });
    return someNodeSupportsMark;
  });
}

var setMark = function setMark(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref76) {
    var tr = _ref76.tr,
        state = _ref76.state,
        dispatch = _ref76.dispatch;
    var selection = tr.selection;
    var empty = selection.empty,
        ranges = selection.ranges;
    var type = getMarkType(typeOrName, state.schema);

    if (dispatch) {
      if (empty) {
        var oldAttributes = getMarkAttributes(state, type);
        tr.addStoredMark(type.create(_objectSpread(_objectSpread({}, oldAttributes), attributes)));
      } else {
        ranges.forEach(function (range) {
          var from = range.$from.pos;
          var to = range.$to.pos;
          state.doc.nodesBetween(from, to, function (node, pos) {
            var trimmedFrom = Math.max(pos, from);
            var trimmedTo = Math.min(pos + node.nodeSize, to);
            var someHasMark = node.marks.find(function (mark) {
              return mark.type === type;
            }); // if there is already a mark of this type
            // we know that we have to merge its attributes
            // otherwise we add a fresh new mark

            if (someHasMark) {
              node.marks.forEach(function (mark) {
                if (type === mark.type) {
                  tr.addMark(trimmedFrom, trimmedTo, type.create(_objectSpread(_objectSpread({}, mark.attrs), attributes)));
                }
              });
            } else {
              tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
            }
          });
        });
      }
    }

    return canSetMark(state, tr, type);
  };
};

var setMeta = function setMeta(key, value) {
  return function (_ref77) {
    var tr = _ref77.tr;
    tr.setMeta(key, value);
    return true;
  };
};

var setNode = function setNode(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref78) {
    var state = _ref78.state,
        dispatch = _ref78.dispatch,
        chain = _ref78.chain;
    var type = getNodeType(typeOrName, state.schema);
    var attributesToCopy;

    if (state.selection.$anchor.sameParent(state.selection.$head)) {
      // only copy attributes if the selection is pointing to a node of the same type
      attributesToCopy = state.selection.$anchor.parent.attrs;
    } // TODO: use a fallback like insertContent?


    if (!type.isTextblock) {
      console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
      return false;
    }

    return chain() // try to convert node to default node if needed
    .command(function (_ref79) {
      var commands = _ref79.commands;
      var canSetBlock = setBlockType(type, _objectSpread(_objectSpread({}, attributesToCopy), attributes))(state);

      if (canSetBlock) {
        return true;
      }

      return commands.clearNodes();
    }).command(function (_ref80) {
      var updatedState = _ref80.state;
      return setBlockType(type, _objectSpread(_objectSpread({}, attributesToCopy), attributes))(updatedState, dispatch);
    }).run();
  };
};

var setNodeSelection = function setNodeSelection(position) {
  return function (_ref81) {
    var tr = _ref81.tr,
        dispatch = _ref81.dispatch;

    if (dispatch) {
      var doc = tr.doc;
      var from = minMax(position, 0, doc.content.size);
      var selection = NodeSelection.create(doc, from);
      tr.setSelection(selection);
    }

    return true;
  };
};

var setTextSelection = function setTextSelection(position) {
  return function (_ref82) {
    var tr = _ref82.tr,
        dispatch = _ref82.dispatch;

    if (dispatch) {
      var doc = tr.doc;

      var _ref83 = typeof position === 'number' ? {
        from: position,
        to: position
      } : position,
          from = _ref83.from,
          to = _ref83.to;

      var minPos = TextSelection.atStart(doc).from;
      var maxPos = TextSelection.atEnd(doc).to;
      var resolvedFrom = minMax(from, minPos, maxPos);
      var resolvedEnd = minMax(to, minPos, maxPos);
      var selection = TextSelection.create(doc, resolvedFrom, resolvedEnd);
      tr.setSelection(selection);
    }

    return true;
  };
};

var sinkListItem = function sinkListItem(typeOrName) {
  return function (_ref84) {
    var state = _ref84.state,
        dispatch = _ref84.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    return sinkListItem$1(type)(state, dispatch);
  };
};

function ensureMarks(state, splittableMarks) {
  var marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();

  if (marks) {
    var filteredMarks = marks.filter(function (mark) {
      return splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name);
    });
    state.tr.ensureMarks(filteredMarks);
  }
}

var splitBlock = function splitBlock() {
  var _ref85 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref85$keepMarks = _ref85.keepMarks,
      keepMarks = _ref85$keepMarks === void 0 ? true : _ref85$keepMarks;

  return function (_ref86) {
    var tr = _ref86.tr,
        state = _ref86.state,
        dispatch = _ref86.dispatch,
        editor = _ref86.editor;
    var selection = tr.selection,
        doc = tr.doc;
    var $from = selection.$from,
        $to = selection.$to;
    var extensionAttributes = editor.extensionManager.attributes;
    var newAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);

    if (selection instanceof NodeSelection && selection.node.isBlock) {
      if (!$from.parentOffset || !canSplit(doc, $from.pos)) {
        return false;
      }

      if (dispatch) {
        if (keepMarks) {
          ensureMarks(state, editor.extensionManager.splittableMarks);
        }

        tr.split($from.pos).scrollIntoView();
      }

      return true;
    }

    if (!$from.parent.isBlock) {
      return false;
    }

    var atEnd = $to.parentOffset === $to.parent.content.size;
    var deflt = $from.depth === 0 ? undefined : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
    var types = atEnd && deflt ? [{
      type: deflt,
      attrs: newAttributes
    }] : undefined;
    var can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);

    if (!types && !can && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{
      type: deflt
    }] : undefined)) {
      can = true;
      types = deflt ? [{
        type: deflt,
        attrs: newAttributes
      }] : undefined;
    }

    if (dispatch) {
      if (can) {
        if (selection instanceof TextSelection) {
          tr.deleteSelection();
        }

        tr.split(tr.mapping.map($from.pos), 1, types);

        if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
          var _first = tr.mapping.map($from.before());

          var $first = tr.doc.resolve(_first);

          if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
            tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
          }
        }
      }

      if (keepMarks) {
        ensureMarks(state, editor.extensionManager.splittableMarks);
      }

      tr.scrollIntoView();
    }

    return can;
  };
};

var splitListItem = function splitListItem(typeOrName) {
  var overrideAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref87) {
    var tr = _ref87.tr,
        state = _ref87.state,
        dispatch = _ref87.dispatch,
        editor = _ref87.editor;

    var _a;

    var type = getNodeType(typeOrName, state.schema);
    var _state$selection7 = state.selection,
        $from = _state$selection7.$from,
        $to = _state$selection7.$to; // @ts-ignore
    // eslint-disable-next-line

    var node = state.selection.node;

    if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) {
      return false;
    }

    var grandParent = $from.node(-1);

    if (grandParent.type !== type) {
      return false;
    }

    var extensionAttributes = editor.extensionManager.attributes;

    if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
      // In an empty block. If this is a nested list, the wrapping
      // list item should be split. Otherwise, bail out and let next
      // command handle lifting.
      if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) {
        return false;
      }

      if (dispatch) {
        var wrap = Fragment.empty; // eslint-disable-next-line

        var depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3; // Build a fragment containing empty versions of the structure
        // from the outer list item to the parent node of the cursor

        for (var d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1) {
          wrap = Fragment.from($from.node(d).copy(wrap));
        } // eslint-disable-next-line


        var depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3; // Add a second list item with an empty default start node

        var _newNextTypeAttributes = _objectSpread(_objectSpread({}, getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs)), overrideAttrs);

        var _nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(_newNextTypeAttributes)) || undefined;

        wrap = wrap.append(Fragment.from(type.createAndFill(null, _nextType) || undefined));
        var start = $from.before($from.depth - (depthBefore - 1));
        tr.replace(start, $from.after(-depthAfter), new Slice(wrap, 4 - depthBefore, 0));
        var sel = -1;
        tr.doc.nodesBetween(start, tr.doc.content.size, function (n, pos) {
          if (sel > -1) {
            return false;
          }

          if (n.isTextblock && n.content.size === 0) {
            sel = pos + 1;
          }
        });

        if (sel > -1) {
          tr.setSelection(TextSelection.near(tr.doc.resolve(sel)));
        }

        tr.scrollIntoView();
      }

      return true;
    }

    var nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;

    var newTypeAttributes = _objectSpread(_objectSpread({}, getSplittedAttributes(extensionAttributes, grandParent.type.name, grandParent.attrs)), overrideAttrs);

    var newNextTypeAttributes = _objectSpread(_objectSpread({}, getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs)), overrideAttrs);

    tr.delete($from.pos, $to.pos);
    var types = nextType ? [{
      type: type,
      attrs: newTypeAttributes
    }, {
      type: nextType,
      attrs: newNextTypeAttributes
    }] : [{
      type: type,
      attrs: newTypeAttributes
    }];

    if (!canSplit(tr.doc, $from.pos, 2)) {
      return false;
    }

    if (dispatch) {
      var selection = state.selection,
          storedMarks = state.storedMarks;
      var splittableMarks = editor.extensionManager.splittableMarks;
      var marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
      tr.split($from.pos, 2, types).scrollIntoView();

      if (!marks || !dispatch) {
        return true;
      }

      var filteredMarks = marks.filter(function (mark) {
        return splittableMarks.includes(mark.type.name);
      });
      tr.ensureMarks(filteredMarks);
    }

    return true;
  };
};

var joinListBackwards = function joinListBackwards(tr, listType) {
  var list = findParentNode(function (node) {
    return node.type === listType;
  })(tr.selection);

  if (!list) {
    return true;
  }

  var before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);

  if (before === undefined) {
    return true;
  }

  var nodeBefore = tr.doc.nodeAt(before);
  var canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && canJoin(tr.doc, list.pos);

  if (!canJoinBackwards) {
    return true;
  }

  tr.join(list.pos);
  return true;
};

var joinListForwards = function joinListForwards(tr, listType) {
  var list = findParentNode(function (node) {
    return node.type === listType;
  })(tr.selection);

  if (!list) {
    return true;
  }

  var after = tr.doc.resolve(list.start).after(list.depth);

  if (after === undefined) {
    return true;
  }

  var nodeAfter = tr.doc.nodeAt(after);
  var canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && canJoin(tr.doc, after);

  if (!canJoinForwards) {
    return true;
  }

  tr.join(after);
  return true;
};

var toggleList = function toggleList(listTypeOrName, itemTypeOrName, keepMarks) {
  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (_ref88) {
    var editor = _ref88.editor,
        tr = _ref88.tr,
        state = _ref88.state,
        dispatch = _ref88.dispatch,
        chain = _ref88.chain,
        commands = _ref88.commands,
        can = _ref88.can;
    var _editor$extensionMana = editor.extensionManager,
        extensions = _editor$extensionMana.extensions,
        splittableMarks = _editor$extensionMana.splittableMarks;
    var listType = getNodeType(listTypeOrName, state.schema);
    var itemType = getNodeType(itemTypeOrName, state.schema);
    var selection = state.selection,
        storedMarks = state.storedMarks;
    var $from = selection.$from,
        $to = selection.$to;
    var range = $from.blockRange($to);
    var marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();

    if (!range) {
      return false;
    }

    var parentList = findParentNode(function (node) {
      return isList(node.type.name, extensions);
    })(selection);

    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
      // remove list
      if (parentList.node.type === listType) {
        return commands.liftListItem(itemType);
      } // change list type


      if (isList(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) {
        return chain().command(function () {
          tr.setNodeMarkup(parentList.pos, listType);
          return true;
        }).command(function () {
          return joinListBackwards(tr, listType);
        }).command(function () {
          return joinListForwards(tr, listType);
        }).run();
      }
    }

    if (!keepMarks || !marks || !dispatch) {
      return chain() // try to convert node to default node if needed
      .command(function () {
        var canWrapInList = can().wrapInList(listType, attributes);

        if (canWrapInList) {
          return true;
        }

        return commands.clearNodes();
      }).wrapInList(listType, attributes).command(function () {
        return joinListBackwards(tr, listType);
      }).command(function () {
        return joinListForwards(tr, listType);
      }).run();
    }

    return chain() // try to convert node to default node if needed
    .command(function () {
      var canWrapInList = can().wrapInList(listType, attributes);
      var filteredMarks = marks.filter(function (mark) {
        return splittableMarks.includes(mark.type.name);
      });
      tr.ensureMarks(filteredMarks);

      if (canWrapInList) {
        return true;
      }

      return commands.clearNodes();
    }).wrapInList(listType, attributes).command(function () {
      return joinListBackwards(tr, listType);
    }).command(function () {
      return joinListForwards(tr, listType);
    }).run();
  };
};

var toggleMark = function toggleMark(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (_ref89) {
    var state = _ref89.state,
        commands = _ref89.commands;
    var _options$extendEmptyM = options.extendEmptyMarkRange,
        extendEmptyMarkRange = _options$extendEmptyM === void 0 ? false : _options$extendEmptyM;
    var type = getMarkType(typeOrName, state.schema);
    var isActive = isMarkActive(state, type, attributes);

    if (isActive) {
      return commands.unsetMark(type, {
        extendEmptyMarkRange: extendEmptyMarkRange
      });
    }

    return commands.setMark(type, attributes);
  };
};

var toggleNode = function toggleNode(typeOrName, toggleTypeOrName) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (_ref90) {
    var state = _ref90.state,
        commands = _ref90.commands;
    var type = getNodeType(typeOrName, state.schema);
    var toggleType = getNodeType(toggleTypeOrName, state.schema);
    var isActive = isNodeActive(state, type, attributes);
    var attributesToCopy;

    if (state.selection.$anchor.sameParent(state.selection.$head)) {
      // only copy attributes if the selection is pointing to a node of the same type
      attributesToCopy = state.selection.$anchor.parent.attrs;
    }

    if (isActive) {
      return commands.setNode(toggleType, attributesToCopy);
    } // If the node is not active, we want to set the new node type with the given attributes
    // Copying over the attributes from the current node if the selection is pointing to a node of the same type


    return commands.setNode(type, _objectSpread(_objectSpread({}, attributesToCopy), attributes));
  };
};

var toggleWrap = function toggleWrap(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref91) {
    var state = _ref91.state,
        commands = _ref91.commands;
    var type = getNodeType(typeOrName, state.schema);
    var isActive = isNodeActive(state, type, attributes);

    if (isActive) {
      return commands.lift(type);
    }

    return commands.wrapIn(type, attributes);
  };
};

var undoInputRule = function undoInputRule() {
  return function (_ref92) {
    var state = _ref92.state,
        dispatch = _ref92.dispatch;
    var plugins = state.plugins;

    for (var i = 0; i < plugins.length; i += 1) {
      var plugin = plugins[i];
      var undoable = void 0; // @ts-ignore
      // eslint-disable-next-line

      if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
        if (dispatch) {
          var tr = state.tr;
          var toUndo = undoable.transform;

          for (var j = toUndo.steps.length - 1; j >= 0; j -= 1) {
            tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
          }

          if (undoable.text) {
            var marks = tr.doc.resolve(undoable.from).marks();
            tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
          } else {
            tr.delete(undoable.from, undoable.to);
          }
        }

        return true;
      }
    }

    return false;
  };
};

var unsetAllMarks = function unsetAllMarks() {
  return function (_ref93) {
    var tr = _ref93.tr,
        dispatch = _ref93.dispatch;
    var selection = tr.selection;
    var empty = selection.empty,
        ranges = selection.ranges;

    if (empty) {
      return true;
    }

    if (dispatch) {
      ranges.forEach(function (range) {
        tr.removeMark(range.$from.pos, range.$to.pos);
      });
    }

    return true;
  };
};

var unsetMark = function unsetMark(typeOrName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref94) {
    var tr = _ref94.tr,
        state = _ref94.state,
        dispatch = _ref94.dispatch;

    var _a;

    var _options$extendEmptyM2 = options.extendEmptyMarkRange,
        extendEmptyMarkRange = _options$extendEmptyM2 === void 0 ? false : _options$extendEmptyM2;
    var selection = tr.selection;
    var type = getMarkType(typeOrName, state.schema);
    var $from = selection.$from,
        empty = selection.empty,
        ranges = selection.ranges;

    if (!dispatch) {
      return true;
    }

    if (empty && extendEmptyMarkRange) {
      var from = selection.from,
          to = selection.to;
      var attrs = (_a = $from.marks().find(function (mark) {
        return mark.type === type;
      })) === null || _a === void 0 ? void 0 : _a.attrs;
      var range = getMarkRange($from, type, attrs);

      if (range) {
        from = range.from;
        to = range.to;
      }

      tr.removeMark(from, to, type);
    } else {
      ranges.forEach(function (range) {
        tr.removeMark(range.$from.pos, range.$to.pos, type);
      });
    }

    tr.removeStoredMark(type);
    return true;
  };
};

var updateAttributes = function updateAttributes(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref95) {
    var tr = _ref95.tr,
        state = _ref95.state,
        dispatch = _ref95.dispatch;
    var nodeType = null;
    var markType = null;
    var schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);

    if (!schemaType) {
      return false;
    }

    if (schemaType === 'node') {
      nodeType = getNodeType(typeOrName, state.schema);
    }

    if (schemaType === 'mark') {
      markType = getMarkType(typeOrName, state.schema);
    }

    if (dispatch) {
      tr.selection.ranges.forEach(function (range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        var lastPos;
        var lastNode;
        var trimmedFrom;
        var trimmedTo;

        if (tr.selection.empty) {
          state.doc.nodesBetween(from, to, function (node, pos) {
            if (nodeType && nodeType === node.type) {
              trimmedFrom = Math.max(pos, from);
              trimmedTo = Math.min(pos + node.nodeSize, to);
              lastPos = pos;
              lastNode = node;
            }
          });
        } else {
          state.doc.nodesBetween(from, to, function (node, pos) {
            if (pos < from && nodeType && nodeType === node.type) {
              trimmedFrom = Math.max(pos, from);
              trimmedTo = Math.min(pos + node.nodeSize, to);
              lastPos = pos;
              lastNode = node;
            }

            if (pos >= from && pos <= to) {
              if (nodeType && nodeType === node.type) {
                tr.setNodeMarkup(pos, undefined, _objectSpread(_objectSpread({}, node.attrs), attributes));
              }

              if (markType && node.marks.length) {
                node.marks.forEach(function (mark) {
                  if (markType === mark.type) {
                    var trimmedFrom2 = Math.max(pos, from);
                    var trimmedTo2 = Math.min(pos + node.nodeSize, to);
                    tr.addMark(trimmedFrom2, trimmedTo2, markType.create(_objectSpread(_objectSpread({}, mark.attrs), attributes)));
                  }
                });
              }
            }
          });
        }

        if (lastNode) {
          if (lastPos !== undefined) {
            tr.setNodeMarkup(lastPos, undefined, _objectSpread(_objectSpread({}, lastNode.attrs), attributes));
          }

          if (markType && lastNode.marks.length) {
            lastNode.marks.forEach(function (mark) {
              if (markType === mark.type) {
                tr.addMark(trimmedFrom, trimmedTo, markType.create(_objectSpread(_objectSpread({}, mark.attrs), attributes)));
              }
            });
          }
        }
      });
    }

    return true;
  };
};

var wrapIn = function wrapIn(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref96) {
    var state = _ref96.state,
        dispatch = _ref96.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    return wrapIn$1(type, attributes)(state, dispatch);
  };
};

var wrapInList = function wrapInList(typeOrName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref97) {
    var state = _ref97.state,
        dispatch = _ref97.dispatch;
    var type = getNodeType(typeOrName, state.schema);
    return wrapInList$1(type, attributes)(state, dispatch);
  };
};

var commands = /*#__PURE__*/Object.freeze({
  __proto__: null,
  blur: blur,
  clearContent: clearContent,
  clearNodes: clearNodes,
  command: command,
  createParagraphNear: createParagraphNear,
  cut: cut,
  deleteCurrentNode: deleteCurrentNode,
  deleteNode: deleteNode,
  deleteRange: deleteRange,
  deleteSelection: deleteSelection,
  enter: enter,
  exitCode: exitCode,
  extendMarkRange: extendMarkRange,
  first: first,
  focus: focus,
  forEach: forEach,
  insertContent: insertContent,
  insertContentAt: insertContentAt,
  joinBackward: joinBackward,
  joinDown: joinDown,
  joinForward: joinForward,
  joinItemBackward: joinItemBackward,
  joinItemForward: joinItemForward,
  joinTextblockBackward: joinTextblockBackward,
  joinTextblockForward: joinTextblockForward,
  joinUp: joinUp,
  keyboardShortcut: keyboardShortcut,
  lift: lift,
  liftEmptyBlock: liftEmptyBlock,
  liftListItem: liftListItem,
  newlineInCode: newlineInCode,
  resetAttributes: resetAttributes,
  scrollIntoView: scrollIntoView,
  selectAll: selectAll,
  selectNodeBackward: selectNodeBackward,
  selectNodeForward: selectNodeForward,
  selectParentNode: selectParentNode,
  selectTextblockEnd: selectTextblockEnd,
  selectTextblockStart: selectTextblockStart,
  setContent: setContent,
  setMark: setMark,
  setMeta: setMeta,
  setNode: setNode,
  setNodeSelection: setNodeSelection,
  setTextSelection: setTextSelection,
  sinkListItem: sinkListItem,
  splitBlock: splitBlock,
  splitListItem: splitListItem,
  toggleList: toggleList,
  toggleMark: toggleMark,
  toggleNode: toggleNode,
  toggleWrap: toggleWrap,
  undoInputRule: undoInputRule,
  unsetAllMarks: unsetAllMarks,
  unsetMark: unsetMark,
  updateAttributes: updateAttributes,
  wrapIn: wrapIn,
  wrapInList: wrapInList
});
var Commands = Extension.create({
  name: 'commands',
  addCommands: function addCommands() {
    return _objectSpread({}, commands);
  }
});
var Drop = Extension.create({
  name: 'drop',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this17 = this;

    return [new Plugin({
      key: new PluginKey('tiptapDrop'),
      props: {
        handleDrop: function handleDrop(_, e, slice, moved) {
          _this17.editor.emit('drop', {
            editor: _this17.editor,
            event: e,
            slice: slice,
            moved: moved
          });
        }
      }
    })];
  }
});
var Editable = Extension.create({
  name: 'editable',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this18 = this;

    return [new Plugin({
      key: new PluginKey('editable'),
      props: {
        editable: function editable() {
          return _this18.editor.options.editable;
        }
      }
    })];
  }
});
var FocusEvents = Extension.create({
  name: 'focusEvents',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var editor = this.editor;
    return [new Plugin({
      key: new PluginKey('focusEvents'),
      props: {
        handleDOMEvents: {
          focus: function focus(view, event) {
            editor.isFocused = true;
            var transaction = editor.state.tr.setMeta('focus', {
              event: event
            }).setMeta('addToHistory', false);
            view.dispatch(transaction);
            return false;
          },
          blur: function blur(view, event) {
            editor.isFocused = false;
            var transaction = editor.state.tr.setMeta('blur', {
              event: event
            }).setMeta('addToHistory', false);
            view.dispatch(transaction);
            return false;
          }
        }
      }
    })];
  }
});
var Keymap = Extension.create({
  name: 'keymap',
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this19 = this;

    var handleBackspace = function handleBackspace() {
      return _this19.editor.commands.first(function (_ref98) {
        var commands = _ref98.commands;
        return [function () {
          return commands.undoInputRule();
        }, // maybe convert first text block node to default node
        function () {
          return commands.command(function (_ref99) {
            var tr = _ref99.tr;
            var selection = tr.selection,
                doc = tr.doc;
            var empty = selection.empty,
                $anchor = selection.$anchor;
            var pos = $anchor.pos,
                parent = $anchor.parent;
            var $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
            var parentIsIsolating = $parentPos.parent.type.spec.isolating;
            var parentPos = $anchor.pos - $anchor.parentOffset;
            var isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : Selection.atStart(doc).from === pos;

            if (!empty || !parent.type.isTextblock || parent.textContent.length || !isAtStart || isAtStart && $anchor.parent.type.name === 'paragraph' // prevent clearNodes when no nodes to clear, otherwise history stack is appended
            ) {
                return false;
              }

            return commands.clearNodes();
          });
        }, function () {
          return commands.deleteSelection();
        }, function () {
          return commands.joinBackward();
        }, function () {
          return commands.selectNodeBackward();
        }];
      });
    };

    var handleDelete = function handleDelete() {
      return _this19.editor.commands.first(function (_ref100) {
        var commands = _ref100.commands;
        return [function () {
          return commands.deleteSelection();
        }, function () {
          return commands.deleteCurrentNode();
        }, function () {
          return commands.joinForward();
        }, function () {
          return commands.selectNodeForward();
        }];
      });
    };

    var handleEnter = function handleEnter() {
      return _this19.editor.commands.first(function (_ref101) {
        var commands = _ref101.commands;
        return [function () {
          return commands.newlineInCode();
        }, function () {
          return commands.createParagraphNear();
        }, function () {
          return commands.liftEmptyBlock();
        }, function () {
          return commands.splitBlock();
        }];
      });
    };

    var baseKeymap = {
      Enter: handleEnter,
      'Mod-Enter': function ModEnter() {
        return _this19.editor.commands.exitCode();
      },
      Backspace: handleBackspace,
      'Mod-Backspace': handleBackspace,
      'Shift-Backspace': handleBackspace,
      Delete: handleDelete,
      'Mod-Delete': handleDelete,
      'Mod-a': function ModA() {
        return _this19.editor.commands.selectAll();
      }
    };

    var pcKeymap = _objectSpread({}, baseKeymap);

    var macKeymap = _objectSpread(_objectSpread({}, baseKeymap), {}, {
      'Ctrl-h': handleBackspace,
      'Alt-Backspace': handleBackspace,
      'Ctrl-d': handleDelete,
      'Ctrl-Alt-Backspace': handleDelete,
      'Alt-Delete': handleDelete,
      'Alt-d': handleDelete,
      'Ctrl-a': function CtrlA() {
        return _this19.editor.commands.selectTextblockStart();
      },
      'Ctrl-e': function CtrlE() {
        return _this19.editor.commands.selectTextblockEnd();
      }
    });

    if (isiOS() || isMacOS()) {
      return macKeymap;
    }

    return pcKeymap;
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this20 = this;

    return [// With this plugin we check if the whole document was selected and deleted.
    // In this case we will additionally call `clearNodes()` to convert e.g. a heading
    // to a paragraph if necessary.
    // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
    // with many other commands.
    new Plugin({
      key: new PluginKey('clearDocument'),
      appendTransaction: function appendTransaction(transactions, oldState, newState) {
        if (transactions.some(function (tr) {
          return tr.getMeta('composition');
        })) {
          return;
        }

        var docChanges = transactions.some(function (transaction) {
          return transaction.docChanged;
        }) && !oldState.doc.eq(newState.doc);
        var ignoreTr = transactions.some(function (transaction) {
          return transaction.getMeta('preventClearDocument');
        });

        if (!docChanges || ignoreTr) {
          return;
        }

        var _oldState$selection = oldState.selection,
            empty = _oldState$selection.empty,
            from = _oldState$selection.from,
            to = _oldState$selection.to;
        var allFrom = Selection.atStart(oldState.doc).from;
        var allEnd = Selection.atEnd(oldState.doc).to;
        var allWasSelected = from === allFrom && to === allEnd;

        if (empty || !allWasSelected) {
          return;
        }

        var isEmpty = isNodeEmpty(newState.doc);

        if (!isEmpty) {
          return;
        }

        var tr = newState.tr;
        var state = createChainableState({
          state: newState,
          transaction: tr
        });

        var _CommandManager3 = new CommandManager({
          editor: _this20.editor,
          state: state
        }),
            commands = _CommandManager3.commands;

        commands.clearNodes();

        if (!tr.steps.length) {
          return;
        }

        return tr;
      }
    })];
  }
});
var Paste = Extension.create({
  name: 'paste',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this21 = this;

    return [new Plugin({
      key: new PluginKey('tiptapPaste'),
      props: {
        handlePaste: function handlePaste(_view, e, slice) {
          _this21.editor.emit('paste', {
            editor: _this21.editor,
            event: e,
            slice: slice
          });
        }
      }
    })];
  }
});
var Tabindex = Extension.create({
  name: 'tabindex',
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this22 = this;

    return [new Plugin({
      key: new PluginKey('tabindex'),
      props: {
        attributes: function attributes() {
          return _this22.editor.isEditable ? {
            tabindex: '0'
          } : {};
        }
      }
    })];
  }
});
var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: ClipboardTextSerializer,
  Commands: Commands,
  Drop: Drop,
  Editable: Editable,
  FocusEvents: FocusEvents,
  Keymap: Keymap,
  Paste: Paste,
  Tabindex: Tabindex
});

var NodePos = /*#__PURE__*/function () {
  function NodePos(pos, editor) {
    var isBlock = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var node = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, NodePos);

    this.currentNode = null;
    this.actualDepth = null;
    this.isBlock = isBlock;
    this.resolvedPos = pos;
    this.editor = editor;
    this.currentNode = node;
  }

  _createClass(NodePos, [{
    key: "name",
    get: function get() {
      return this.node.type.name;
    }
  }, {
    key: "node",
    get: function get() {
      return this.currentNode || this.resolvedPos.node();
    }
  }, {
    key: "element",
    get: function get() {
      return this.editor.view.domAtPos(this.pos).node;
    }
  }, {
    key: "depth",
    get: function get() {
      var _a;

      return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
  }, {
    key: "pos",
    get: function get() {
      return this.resolvedPos.pos;
    }
  }, {
    key: "content",
    get: function get() {
      return this.node.content;
    },
    set: function set(content) {
      var from = this.from;
      var to = this.to;

      if (this.isBlock) {
        if (this.content.size === 0) {
          console.error("You can\u2019t set content on a block node. Tried to set content on ".concat(this.name, " at ").concat(this.pos));
          return;
        }

        from = this.from + 1;
        to = this.to - 1;
      }

      this.editor.commands.insertContentAt({
        from: from,
        to: to
      }, content);
    }
  }, {
    key: "attributes",
    get: function get() {
      return this.node.attrs;
    }
  }, {
    key: "textContent",
    get: function get() {
      return this.node.textContent;
    }
  }, {
    key: "size",
    get: function get() {
      return this.node.nodeSize;
    }
  }, {
    key: "from",
    get: function get() {
      if (this.isBlock) {
        return this.pos;
      }

      return this.resolvedPos.start(this.resolvedPos.depth);
    }
  }, {
    key: "range",
    get: function get() {
      return {
        from: this.from,
        to: this.to
      };
    }
  }, {
    key: "to",
    get: function get() {
      if (this.isBlock) {
        return this.pos + this.size;
      }

      return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
  }, {
    key: "parent",
    get: function get() {
      if (this.depth === 0) {
        return null;
      }

      var parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
      var $pos = this.resolvedPos.doc.resolve(parentPos);
      return new NodePos($pos, this.editor);
    }
  }, {
    key: "before",
    get: function get() {
      var $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));

      if ($pos.depth !== this.depth) {
        $pos = this.resolvedPos.doc.resolve(this.from - 3);
      }

      return new NodePos($pos, this.editor);
    }
  }, {
    key: "after",
    get: function get() {
      var $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));

      if ($pos.depth !== this.depth) {
        $pos = this.resolvedPos.doc.resolve(this.to + 3);
      }

      return new NodePos($pos, this.editor);
    }
  }, {
    key: "children",
    get: function get() {
      var _this23 = this;

      var children = [];
      this.node.content.forEach(function (node, offset) {
        var isBlock = node.isBlock && !node.isTextblock;
        var isNonTextAtom = node.isAtom && !node.isText;
        var targetPos = _this23.pos + offset + (isNonTextAtom ? 0 : 1);

        var $pos = _this23.resolvedPos.doc.resolve(targetPos);

        if (!isBlock && $pos.depth <= _this23.depth) {
          return;
        }

        var childNodePos = new NodePos($pos, _this23.editor, isBlock, isBlock ? node : null);

        if (isBlock) {
          childNodePos.actualDepth = _this23.depth + 1;
        }

        children.push(new NodePos($pos, _this23.editor, isBlock, isBlock ? node : null));
      });
      return children;
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.children[0] || null;
    }
  }, {
    key: "lastChild",
    get: function get() {
      var children = this.children;
      return children[children.length - 1] || null;
    }
  }, {
    key: "closest",
    value: function closest(selector) {
      var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var node = null;
      var currentNode = this.parent;

      while (currentNode && !node) {
        if (currentNode.node.type.name === selector) {
          if (Object.keys(attributes).length > 0) {
            var nodeAttributes = currentNode.node.attrs;
            var attrKeys = Object.keys(attributes);

            for (var _index = 0; _index < attrKeys.length; _index += 1) {
              var key = attrKeys[_index];

              if (nodeAttributes[key] !== attributes[key]) {
                break;
              }
            }
          } else {
            node = currentNode;
          }
        }

        currentNode = currentNode.parent;
      }

      return node;
    }
  }, {
    key: "querySelector",
    value: function querySelector(selector) {
      var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
  }, {
    key: "querySelectorAll",
    value: function querySelectorAll(selector) {
      var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var firstItemOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var nodes = [];

      if (!this.children || this.children.length === 0) {
        return nodes;
      }

      var attrKeys = Object.keys(attributes);
      /**
       * Finds all children recursively that match the selector and attributes
       * If firstItemOnly is true, it will return the first item found
       */

      this.children.forEach(function (childPos) {
        // If we already found a node and we only want the first item, we dont need to keep going
        if (firstItemOnly && nodes.length > 0) {
          return;
        }

        if (childPos.node.type.name === selector) {
          var doesAllAttributesMatch = attrKeys.every(function (key) {
            return attributes[key] === childPos.node.attrs[key];
          });

          if (doesAllAttributesMatch) {
            nodes.push(childPos);
          }
        } // If we already found a node and we only want the first item, we can stop here and skip the recursion


        if (firstItemOnly && nodes.length > 0) {
          return;
        }

        nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
      });
      return nodes;
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(attributes) {
      var tr = this.editor.state.tr;
      tr.setNodeMarkup(this.from, undefined, _objectSpread(_objectSpread({}, this.node.attrs), attributes));
      this.editor.view.dispatch(tr);
    }
  }]);

  return NodePos;
}();

var style = ".ProseMirror {\n  position: relative;\n}\n\n.ProseMirror {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  white-space: break-spaces;\n  -webkit-font-variant-ligatures: none;\n  font-variant-ligatures: none;\n  font-feature-settings: \"liga\" 0; /* the above doesn't seem to work in Edge */\n}\n\n.ProseMirror [contenteditable=\"false\"] {\n  white-space: normal;\n}\n\n.ProseMirror [contenteditable=\"false\"] [contenteditable=\"true\"] {\n  white-space: pre-wrap;\n}\n\n.ProseMirror pre {\n  white-space: pre-wrap;\n}\n\nimg.ProseMirror-separator {\n  display: inline !important;\n  border: none !important;\n  margin: 0 !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n.ProseMirror-gapcursor {\n  display: none;\n  pointer-events: none;\n  position: absolute;\n  margin: 0;\n}\n\n.ProseMirror-gapcursor:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -2px;\n  width: 20px;\n  border-top: 1px solid black;\n  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;\n}\n\n@keyframes ProseMirror-cursor-blink {\n  to {\n    visibility: hidden;\n  }\n}\n\n.ProseMirror-hideselection *::selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection *::-moz-selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection * {\n  caret-color: transparent;\n}\n\n.ProseMirror-focused .ProseMirror-gapcursor {\n  display: block;\n}\n\n.tippy-box[data-animation=fade][data-state=hidden] {\n  opacity: 0\n}";

function createStyleTag(style, nonce, suffix) {
  var tiptapStyleTag = document.querySelector("style[data-tiptap-style".concat(suffix ? "-".concat(suffix) : '', "]"));

  if (tiptapStyleTag !== null) {
    return tiptapStyleTag;
  }

  var styleNode = document.createElement('style');

  if (nonce) {
    styleNode.setAttribute('nonce', nonce);
  }

  styleNode.setAttribute("data-tiptap-style".concat(suffix ? "-".concat(suffix) : ''), '');
  styleNode.innerHTML = style;
  document.getElementsByTagName('head')[0].appendChild(styleNode);
  return styleNode;
}

var Editor = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Editor, _EventEmitter);

  var _super = _createSuper(Editor);

  function Editor() {
    var _this24;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Editor);

    _this24 = _super.call(this);
    _this24.isFocused = false;
    /**
     * The editor is considered initialized after the `create` event has been emitted.
     */

    _this24.isInitialized = false;
    _this24.extensionStorage = {};
    _this24.options = {
      element: document.createElement('div'),
      content: '',
      injectCSS: true,
      injectNonce: undefined,
      extensions: [],
      autofocus: false,
      editable: true,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: true,
      enablePasteRules: true,
      enableCoreExtensions: true,
      enableContentCheck: false,
      onBeforeCreate: function onBeforeCreate() {
        return null;
      },
      onCreate: function onCreate() {
        return null;
      },
      onUpdate: function onUpdate() {
        return null;
      },
      onSelectionUpdate: function onSelectionUpdate() {
        return null;
      },
      onTransaction: function onTransaction() {
        return null;
      },
      onFocus: function onFocus() {
        return null;
      },
      onBlur: function onBlur() {
        return null;
      },
      onDestroy: function onDestroy() {
        return null;
      },
      onContentError: function onContentError(_ref102) {
        var error = _ref102.error;
        throw error;
      },
      onPaste: function onPaste() {
        return null;
      },
      onDrop: function onDrop() {
        return null;
      }
    };
    _this24.isCapturingTransaction = false;
    _this24.capturedTransaction = null;

    _this24.setOptions(options);

    _this24.createExtensionManager();

    _this24.createCommandManager();

    _this24.createSchema();

    _this24.on('beforeCreate', _this24.options.onBeforeCreate);

    _this24.emit('beforeCreate', {
      editor: _assertThisInitialized(_this24)
    });

    _this24.on('contentError', _this24.options.onContentError);

    _this24.createView();

    _this24.injectCSS();

    _this24.on('create', _this24.options.onCreate);

    _this24.on('update', _this24.options.onUpdate);

    _this24.on('selectionUpdate', _this24.options.onSelectionUpdate);

    _this24.on('transaction', _this24.options.onTransaction);

    _this24.on('focus', _this24.options.onFocus);

    _this24.on('blur', _this24.options.onBlur);

    _this24.on('destroy', _this24.options.onDestroy);

    _this24.on('drop', function (_ref103) {
      var event = _ref103.event,
          slice = _ref103.slice,
          moved = _ref103.moved;
      return _this24.options.onDrop(event, slice, moved);
    });

    _this24.on('paste', function (_ref104) {
      var event = _ref104.event,
          slice = _ref104.slice;
      return _this24.options.onPaste(event, slice);
    });

    window.setTimeout(function () {
      if (_this24.isDestroyed) {
        return;
      }

      _this24.commands.focus(_this24.options.autofocus);

      _this24.emit('create', {
        editor: _assertThisInitialized(_this24)
      });

      _this24.isInitialized = true;
    }, 0);
    return _this24;
  }
  /**
   * Returns the editor storage.
   */


  _createClass(Editor, [{
    key: "storage",
    get: function get() {
      return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */

  }, {
    key: "commands",
    get: function get() {
      return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */

  }, {
    key: "chain",
    value: function chain() {
      return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */

  }, {
    key: "can",
    value: function can() {
      return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */

  }, {
    key: "injectCSS",
    value: function injectCSS() {
      if (this.options.injectCSS && document) {
        this.css = createStyleTag(style, this.options.injectNonce);
      }
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */

  }, {
    key: "setOptions",
    value: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.options = _objectSpread(_objectSpread({}, this.options), options);

      if (!this.view || !this.state || this.isDestroyed) {
        return;
      }

      if (this.options.editorProps) {
        this.view.setProps(this.options.editorProps);
      }

      this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */

  }, {
    key: "setEditable",
    value: function setEditable(editable) {
      var emitUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.setOptions({
        editable: editable
      });

      if (emitUpdate) {
        this.emit('update', {
          editor: this,
          transaction: this.state.tr
        });
      }
    }
    /**
     * Returns whether the editor is editable.
     */

  }, {
    key: "isEditable",
    get: function get() {
      // since plugins are applied after creating the view
      // `editable` is always `true` for one tick.
      // that’s why we also have to check for `options.editable`
      return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */

  }, {
    key: "state",
    get: function get() {
      return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     * @returns The new editor state
     */

  }, {
    key: "registerPlugin",
    value: function registerPlugin(plugin, handlePlugins) {
      var plugins = isFunction(handlePlugins) ? handlePlugins(plugin, _toConsumableArray(this.state.plugins)) : [].concat(_toConsumableArray(this.state.plugins), [plugin]);
      var state = this.state.reconfigure({
        plugins: plugins
      });
      this.view.updateState(state);
      return state;
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKeyToRemove The plugins name
     * @returns The new editor state or undefined if the editor is destroyed
     */

  }, {
    key: "unregisterPlugin",
    value: function unregisterPlugin(nameOrPluginKeyToRemove) {
      if (this.isDestroyed) {
        return undefined;
      }

      var prevPlugins = this.state.plugins;
      var plugins = prevPlugins;
      [].concat(nameOrPluginKeyToRemove).forEach(function (nameOrPluginKey) {
        // @ts-ignore
        var name = typeof nameOrPluginKey === 'string' ? "".concat(nameOrPluginKey, "$") : nameOrPluginKey.key; // @ts-ignore

        plugins = prevPlugins.filter(function (plugin) {
          return !plugin.key.startsWith(name);
        });
      });

      if (prevPlugins.length === plugins.length) {
        // No plugin was removed, so we don’t need to update the state
        return undefined;
      }

      var state = this.state.reconfigure({
        plugins: plugins
      });
      this.view.updateState(state);
      return state;
    }
    /**
     * Creates an extension manager.
     */

  }, {
    key: "createExtensionManager",
    value: function createExtensionManager() {
      var _this25 = this;

      var _a, _b;

      var coreExtensions = this.options.enableCoreExtensions ? [Editable, ClipboardTextSerializer.configure({
        blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator
      }), Commands, FocusEvents, Keymap, Tabindex, Drop, Paste].filter(function (ext) {
        if (_typeof(_this25.options.enableCoreExtensions) === 'object') {
          return _this25.options.enableCoreExtensions[ext.name] !== false;
        }

        return true;
      }) : [];
      var allExtensions = [].concat(_toConsumableArray(coreExtensions), _toConsumableArray(this.options.extensions)).filter(function (extension) {
        return ['extension', 'node', 'mark'].includes(extension === null || extension === void 0 ? void 0 : extension.type);
      });
      this.extensionManager = new ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */

  }, {
    key: "createCommandManager",
    value: function createCommandManager() {
      this.commandManager = new CommandManager({
        editor: this
      });
    }
    /**
     * Creates a ProseMirror schema.
     */

  }, {
    key: "createSchema",
    value: function createSchema() {
      this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */

  }, {
    key: "createView",
    value: function createView() {
      var _this26 = this;

      var _a;

      var doc;

      try {
        doc = createDocument(this.options.content, this.schema, this.options.parseOptions, {
          errorOnInvalidContent: this.options.enableContentCheck
        });
      } catch (e) {
        if (!(e instanceof Error) || !['[tiptap error]: Invalid JSON content', '[tiptap error]: Invalid HTML content'].includes(e.message)) {
          // Not the content error we were expecting
          throw e;
        }

        this.emit('contentError', {
          editor: this,
          error: e,
          disableCollaboration: function disableCollaboration() {
            if (_this26.storage.collaboration) {
              _this26.storage.collaboration.isDisabled = true;
            } // To avoid syncing back invalid content, reinitialize the extensions without the collaboration extension


            _this26.options.extensions = _this26.options.extensions.filter(function (extension) {
              return extension.name !== 'collaboration';
            }); // Restart the initialization process by recreating the extension manager with the new set of extensions

            _this26.createExtensionManager();
          }
        }); // Content is invalid, but attempt to create it anyway, stripping out the invalid parts

        doc = createDocument(this.options.content, this.schema, this.options.parseOptions, {
          errorOnInvalidContent: false
        });
      }

      var selection = resolveFocusPosition(doc, this.options.autofocus);
      this.view = new EditorView(this.options.element, _objectSpread(_objectSpread({}, this.options.editorProps), {}, {
        attributes: _objectSpread({
          // add `role="textbox"` to the editor element
          role: 'textbox'
        }, (_a = this.options.editorProps) === null || _a === void 0 ? void 0 : _a.attributes),
        dispatchTransaction: this.dispatchTransaction.bind(this),
        state: EditorState.create({
          doc: doc,
          selection: selection || undefined
        })
      })); // `editor.view` is not yet available at this time.
      // Therefore we will add all plugins and node views directly afterwards.

      var newState = this.state.reconfigure({
        plugins: this.extensionManager.plugins
      });
      this.view.updateState(newState);
      this.createNodeViews();
      this.prependClass(); // Let’s store the editor instance in the DOM element.
      // So we’ll have access to it for tests.
      // @ts-ignore

      var dom = this.view.dom;
      dom.editor = this;
    }
    /**
     * Creates all node views.
     */

  }, {
    key: "createNodeViews",
    value: function createNodeViews() {
      if (this.view.isDestroyed) {
        return;
      }

      this.view.setProps({
        nodeViews: this.extensionManager.nodeViews
      });
    }
    /**
     * Prepend class name to element.
     */

  }, {
    key: "prependClass",
    value: function prependClass() {
      this.view.dom.className = "tiptap ".concat(this.view.dom.className);
    }
  }, {
    key: "captureTransaction",
    value: function captureTransaction(fn) {
      this.isCapturingTransaction = true;
      fn();
      this.isCapturingTransaction = false;
      var tr = this.capturedTransaction;
      this.capturedTransaction = null;
      return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */

  }, {
    key: "dispatchTransaction",
    value: function dispatchTransaction(transaction) {
      var _this27 = this;

      // if the editor / the view of the editor was destroyed
      // the transaction should not be dispatched as there is no view anymore.
      if (this.view.isDestroyed) {
        return;
      }

      if (this.isCapturingTransaction) {
        if (!this.capturedTransaction) {
          this.capturedTransaction = transaction;
          return;
        }

        transaction.steps.forEach(function (step) {
          var _a;

          return (_a = _this27.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step);
        });
        return;
      }

      var state = this.state.apply(transaction);
      var selectionHasChanged = !this.state.selection.eq(state.selection);
      this.emit('beforeTransaction', {
        editor: this,
        transaction: transaction,
        nextState: state
      });
      this.view.updateState(state);
      this.emit('transaction', {
        editor: this,
        transaction: transaction
      });

      if (selectionHasChanged) {
        this.emit('selectionUpdate', {
          editor: this,
          transaction: transaction
        });
      }

      var focus = transaction.getMeta('focus');
      var blur = transaction.getMeta('blur');

      if (focus) {
        this.emit('focus', {
          editor: this,
          event: focus.event,
          transaction: transaction
        });
      }

      if (blur) {
        this.emit('blur', {
          editor: this,
          event: blur.event,
          transaction: transaction
        });
      }

      if (!transaction.docChanged || transaction.getMeta('preventUpdate')) {
        return;
      }

      this.emit('update', {
        editor: this,
        transaction: transaction
      });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */

  }, {
    key: "getAttributes",
    value: function getAttributes(nameOrType) {
      return _getAttributes(this.state, nameOrType);
    }
  }, {
    key: "isActive",
    value: function isActive(nameOrAttributes, attributesOrUndefined) {
      var name = typeof nameOrAttributes === 'string' ? nameOrAttributes : null;
      var attributes = typeof nameOrAttributes === 'string' ? attributesOrUndefined : nameOrAttributes;
      return _isActive(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */

  }, {
    key: "getJSON",
    value: function getJSON() {
      return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */

  }, {
    key: "getHTML",
    value: function getHTML() {
      return getHTMLFromFragment(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */

  }, {
    key: "getText",
    value: function getText(options) {
      var _ref105 = options || {},
          _ref105$blockSeparato = _ref105.blockSeparator,
          blockSeparator = _ref105$blockSeparato === void 0 ? '\n\n' : _ref105$blockSeparato,
          _ref105$textSerialize = _ref105.textSerializers,
          textSerializers = _ref105$textSerialize === void 0 ? {} : _ref105$textSerialize;

      return _getText(this.state.doc, {
        blockSeparator: blockSeparator,
        textSerializers: _objectSpread(_objectSpread({}, getTextSerializersFromSchema(this.schema)), textSerializers)
      });
    }
    /**
     * Check if there is no content.
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return isNodeEmpty(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */

  }, {
    key: "getCharacterCount",
    value: function getCharacterCount() {
      console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
      return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.emit('destroy');

      if (this.view) {
        // Cleanup our reference to prevent circular references which caused memory leaks
        // @ts-ignore
        var dom = this.view.dom;

        if (dom && dom.editor) {
          delete dom.editor;
        }

        this.view.destroy();
      }

      this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */

  }, {
    key: "isDestroyed",
    get: function get() {
      var _a; // @ts-ignore


      return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
  }, {
    key: "$node",
    value: function $node(selector, attributes) {
      var _a;

      return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
  }, {
    key: "$nodes",
    value: function $nodes(selector, attributes) {
      var _a;

      return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
  }, {
    key: "$pos",
    value: function $pos(pos) {
      var $pos = this.state.doc.resolve(pos);
      return new NodePos($pos, this);
    }
  }, {
    key: "$doc",
    get: function get() {
      return this.$pos(0);
    }
  }]);

  return Editor;
}(EventEmitter);
/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */


function markInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref106) {
      var state = _ref106.state,
          range = _ref106.range,
          match = _ref106.match;
      var attributes = callOrReturn(config.getAttributes, undefined, match);

      if (attributes === false || attributes === null) {
        return null;
      }

      var tr = state.tr;
      var captureGroup = match[match.length - 1];
      var fullMatch = match[0];

      if (captureGroup) {
        var startSpaces = fullMatch.search(/\S/);
        var textStart = range.from + fullMatch.indexOf(captureGroup);
        var textEnd = textStart + captureGroup.length;
        var excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter(function (item) {
          // @ts-ignore
          var excluded = item.mark.type.excluded;
          return excluded.find(function (type) {
            return type === config.type && type !== item.mark.type;
          });
        }).filter(function (item) {
          return item.to > textStart;
        });

        if (excludedMarks.length) {
          return null;
        }

        if (textEnd < range.to) {
          tr.delete(textEnd, range.to);
        }

        if (textStart > range.from) {
          tr.delete(range.from + startSpaces, textStart);
        }

        var markEnd = range.from + startSpaces + captureGroup.length;
        tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
        tr.removeStoredMark(config.type);
      }
    }
  });
}
/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */


function nodeInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref107) {
      var state = _ref107.state,
          range = _ref107.range,
          match = _ref107.match;
      var attributes = callOrReturn(config.getAttributes, undefined, match) || {};
      var tr = state.tr;
      var start = range.from;
      var end = range.to;
      var newNode = config.type.create(attributes);

      if (match[1]) {
        var offset = match[0].lastIndexOf(match[1]);
        var matchStart = start + offset;

        if (matchStart > end) {
          matchStart = end;
        } else {
          end = matchStart + match[1].length;
        } // insert last typed character


        var lastChar = match[0][match[0].length - 1];
        tr.insertText(lastChar, start + match[0].length - 1); // insert node from input rule

        tr.replaceWith(matchStart, end, newNode);
      } else if (match[0]) {
        var insertionStart = config.type.isInline ? start : start - 1;
        tr.insert(insertionStart, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
      }

      tr.scrollIntoView();
    }
  });
}
/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */


function textblockTypeInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref108) {
      var state = _ref108.state,
          range = _ref108.range,
          match = _ref108.match;
      var $start = state.doc.resolve(range.from);
      var attributes = callOrReturn(config.getAttributes, undefined, match) || {};

      if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) {
        return null;
      }

      state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, config.type, attributes);
    }
  });
}
/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */


function textInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref109) {
      var state = _ref109.state,
          range = _ref109.range,
          match = _ref109.match;
      var insert = config.replace;
      var start = range.from;
      var end = range.to;

      if (match[1]) {
        var offset = match[0].lastIndexOf(match[1]);
        insert += match[0].slice(offset + match[1].length);
        start += offset;
        var cutOff = start - end;

        if (cutOff > 0) {
          insert = match[0].slice(offset - cutOff, offset) + insert;
          start = end;
        }
      }

      state.tr.insertText(insert, start, end);
    }
  });
}
/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */


function wrappingInputRule(config) {
  return new InputRule({
    find: config.find,
    handler: function handler(_ref110) {
      var state = _ref110.state,
          range = _ref110.range,
          match = _ref110.match,
          chain = _ref110.chain;
      var attributes = callOrReturn(config.getAttributes, undefined, match) || {};
      var tr = state.tr.delete(range.from, range.to);
      var $start = tr.doc.resolve(range.from);
      var blockRange = $start.blockRange();
      var wrapping = blockRange && findWrapping(blockRange, config.type, attributes);

      if (!wrapping) {
        return null;
      }

      tr.wrap(blockRange, wrapping);

      if (config.keepMarks && config.editor) {
        var selection = state.selection,
            storedMarks = state.storedMarks;
        var splittableMarks = config.editor.extensionManager.splittableMarks;
        var marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();

        if (marks) {
          var filteredMarks = marks.filter(function (mark) {
            return splittableMarks.includes(mark.type.name);
          });
          tr.ensureMarks(filteredMarks);
        }
      }

      if (config.keepAttributes) {
        /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */
        var nodeType = config.type.name === 'bulletList' || config.type.name === 'orderedList' ? 'listItem' : 'taskList';
        chain().updateAttributes(nodeType, attributes).run();
      }

      var before = tr.doc.resolve(range.from - 1).nodeBefore;

      if (before && before.type === config.type && canJoin(tr.doc, range.from - 1) && (!config.joinPredicate || config.joinPredicate(match, before))) {
        tr.join(range.from - 1);
      }
    }
  });
}
/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */


var Node = /*#__PURE__*/function () {
  function Node() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Node);

    this.type = 'node';
    this.name = 'node';
    this.parent = null;
    this.child = null;
    this.config = {
      name: this.name,
      defaultOptions: {}
    };
    this.config = _objectSpread(_objectSpread({}, this.config), config);
    this.name = this.config.name;

    if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
      console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(this.name, "\"."));
    } // TODO: remove `addOptions` fallback


    this.options = this.config.defaultOptions;

    if (this.config.addOptions) {
      this.options = callOrReturn(getExtensionField(this, 'addOptions', {
        name: this.name
      }));
    }

    this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
      name: this.name,
      options: this.options
    })) || {};
  }

  _createClass(Node, [{
    key: "configure",
    value: function configure() {
      var _this28 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // return a new instance so we can use the same extension
      // with different calls of `configure`
      var extension = this.extend(_objectSpread(_objectSpread({}, this.config), {}, {
        addOptions: function addOptions() {
          return mergeDeep(_this28.options, options);
        }
      })); // Always preserve the current name

      extension.name = this.name; // Set the parent to be our parent

      extension.parent = this.parent;
      return extension;
    }
  }, {
    key: "extend",
    value: function extend() {
      var extendedConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var extension = new Node(extendedConfig);
      extension.parent = this;
      this.child = extension;
      extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;

      if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
        console.warn("[tiptap warn]: BREAKING CHANGE: \"defaultOptions\" is deprecated. Please use \"addOptions\" instead. Found in extension: \"".concat(extension.name, "\"."));
      }

      extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
        name: extension.name
      }));
      extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
        name: extension.name,
        options: extension.options
      }));
      return extension;
    }
  }], [{
    key: "create",
    value: function create() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Node(config);
    }
  }]);

  return Node;
}();
/**
 * Node views are used to customize the rendered DOM structure of a node.
 * @see https://tiptap.dev/guide/node-views
 */


var NodeView = /*#__PURE__*/function () {
  function NodeView(component, props, options) {
    _classCallCheck(this, NodeView);

    this.isDragging = false;
    this.component = component;
    this.editor = props.editor;
    this.options = _objectSpread({
      stopEvent: null,
      ignoreMutation: null
    }, options);
    this.extension = props.extension;
    this.node = props.node;
    this.decorations = props.decorations;
    this.innerDecorations = props.innerDecorations;
    this.view = props.view;
    this.HTMLAttributes = props.HTMLAttributes;
    this.getPos = props.getPos;
    this.mount();
  }

  _createClass(NodeView, [{
    key: "mount",
    value: function mount() {
      // eslint-disable-next-line
      return;
    }
  }, {
    key: "dom",
    get: function get() {
      return this.editor.view.dom;
    }
  }, {
    key: "contentDOM",
    get: function get() {
      return null;
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(event) {
      var _a, _b, _c, _d, _e, _f, _g;

      var view = this.editor.view;
      var target = event.target; // get the drag handle element
      // `closest` is not available for text nodes so we may have to use its parent

      var dragHandle = target.nodeType === 3 ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-drag-handle]') : target.closest('[data-drag-handle]');

      if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) {
        return;
      }

      var x = 0;
      var y = 0; // calculate offset for drag element if we use a different drag handle element

      if (this.dom !== dragHandle) {
        var domBox = this.dom.getBoundingClientRect();
        var handleBox = dragHandle.getBoundingClientRect(); // In React, we have to go through nativeEvent to reach offsetX/offsetY.

        var offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
        var offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
        x = handleBox.x - domBox.x + offsetX;
        y = handleBox.y - domBox.y + offsetY;
      }

      (_g = event.dataTransfer) === null || _g === void 0 ? void 0 : _g.setDragImage(this.dom, x, y);
      var pos = this.getPos();

      if (typeof pos !== 'number') {
        return;
      } // we need to tell ProseMirror that we want to move the whole node
      // so we create a NodeSelection


      var selection = NodeSelection.create(view.state.doc, pos);
      var transaction = view.state.tr.setSelection(selection);
      view.dispatch(transaction);
    }
  }, {
    key: "stopEvent",
    value: function stopEvent(event) {
      var _this29 = this;

      var _a;

      if (!this.dom) {
        return false;
      }

      if (typeof this.options.stopEvent === 'function') {
        return this.options.stopEvent({
          event: event
        });
      }

      var target = event.target;
      var isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target)); // any event from child nodes should be handled by ProseMirror

      if (!isInElement) {
        return false;
      }

      var isDragEvent = event.type.startsWith('drag');
      var isDropEvent = event.type === 'drop';
      var isInput = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].includes(target.tagName) || target.isContentEditable; // any input event within node views should be ignored by ProseMirror

      if (isInput && !isDropEvent && !isDragEvent) {
        return true;
      }

      var isEditable = this.editor.isEditable;
      var isDragging = this.isDragging;
      var isDraggable = !!this.node.type.spec.draggable;
      var isSelectable = NodeSelection.isSelectable(this.node);
      var isCopyEvent = event.type === 'copy';
      var isPasteEvent = event.type === 'paste';
      var isCutEvent = event.type === 'cut';
      var isClickEvent = event.type === 'mousedown'; // ProseMirror tries to drag selectable nodes
      // even if `draggable` is set to `false`
      // this fix prevents that

      if (!isDraggable && isSelectable && isDragEvent && event.target === this.dom) {
        event.preventDefault();
      }

      if (isDraggable && isDragEvent && !isDragging && event.target === this.dom) {
        event.preventDefault();
        return false;
      } // we have to store that dragging started


      if (isDraggable && isEditable && !isDragging && isClickEvent) {
        var dragHandle = target.closest('[data-drag-handle]');
        var isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));

        if (isValidDragHandle) {
          this.isDragging = true;
          document.addEventListener('dragend', function () {
            _this29.isDragging = false;
          }, {
            once: true
          });
          document.addEventListener('drop', function () {
            _this29.isDragging = false;
          }, {
            once: true
          });
          document.addEventListener('mouseup', function () {
            _this29.isDragging = false;
          }, {
            once: true
          });
        }
      } // these events are handled by prosemirror


      if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) {
        return false;
      }

      return true;
    }
    /**
     * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
     * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
     * @return `true` if it can safely be ignored.
     */

  }, {
    key: "ignoreMutation",
    value: function ignoreMutation(mutation) {
      if (!this.dom || !this.contentDOM) {
        return true;
      }

      if (typeof this.options.ignoreMutation === 'function') {
        return this.options.ignoreMutation({
          mutation: mutation
        });
      } // a leaf/atom node is like a black box for ProseMirror
      // and should be fully handled by the node view


      if (this.node.isLeaf || this.node.isAtom) {
        return true;
      } // ProseMirror should handle any selections


      if (mutation.type === 'selection') {
        return false;
      } // try to prevent a bug on iOS and Android that will break node views on enter
      // this is because ProseMirror can’t preventDispatch on enter
      // this will lead to a re-render of the node view on enter
      // see: https://github.com/ueberdosis/tiptap/issues/1214
      // see: https://github.com/ueberdosis/tiptap/issues/2534


      if (this.dom.contains(mutation.target) && mutation.type === 'childList' && (isiOS() || isAndroid()) && this.editor.isFocused) {
        var changedNodes = [].concat(_toConsumableArray(Array.from(mutation.addedNodes)), _toConsumableArray(Array.from(mutation.removedNodes))); // we’ll check if every changed node is contentEditable
        // to make sure it’s probably mutated by ProseMirror

        if (changedNodes.every(function (node) {
          return node.isContentEditable;
        })) {
          return false;
        }
      } // we will allow mutation contentDOM with attributes
      // so we can for example adding classes within our node view


      if (this.contentDOM === mutation.target && mutation.type === 'attributes') {
        return true;
      } // ProseMirror should handle any changes within contentDOM


      if (this.contentDOM.contains(mutation.target)) {
        return false;
      }

      return true;
    }
    /**
     * Update the attributes of the prosemirror node.
     */

  }, {
    key: "updateAttributes",
    value: function updateAttributes(attributes) {
      var _this30 = this;

      this.editor.commands.command(function (_ref111) {
        var tr = _ref111.tr;

        var pos = _this30.getPos();

        if (typeof pos !== 'number') {
          return false;
        }

        tr.setNodeMarkup(pos, undefined, _objectSpread(_objectSpread({}, _this30.node.attrs), attributes));
        return true;
      });
    }
    /**
     * Delete the node.
     */

  }, {
    key: "deleteNode",
    value: function deleteNode() {
      var from = this.getPos();

      if (typeof from !== 'number') {
        return;
      }

      var to = from + this.node.nodeSize;
      this.editor.commands.deleteRange({
        from: from,
        to: to
      });
    }
  }]);

  return NodeView;
}();
/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */


function markPasteRule(config) {
  return new PasteRule({
    find: config.find,
    handler: function handler(_ref112) {
      var state = _ref112.state,
          range = _ref112.range,
          match = _ref112.match,
          pasteEvent = _ref112.pasteEvent;
      var attributes = callOrReturn(config.getAttributes, undefined, match, pasteEvent);

      if (attributes === false || attributes === null) {
        return null;
      }

      var tr = state.tr;
      var captureGroup = match[match.length - 1];
      var fullMatch = match[0];
      var markEnd = range.to;

      if (captureGroup) {
        var startSpaces = fullMatch.search(/\S/);
        var textStart = range.from + fullMatch.indexOf(captureGroup);
        var textEnd = textStart + captureGroup.length;
        var excludedMarks = getMarksBetween(range.from, range.to, state.doc).filter(function (item) {
          // @ts-ignore
          var excluded = item.mark.type.excluded;
          return excluded.find(function (type) {
            return type === config.type && type !== item.mark.type;
          });
        }).filter(function (item) {
          return item.to > textStart;
        });

        if (excludedMarks.length) {
          return null;
        }

        if (textEnd < range.to) {
          tr.delete(textEnd, range.to);
        }

        if (textStart > range.from) {
          tr.delete(range.from + startSpaces, textStart);
        }

        markEnd = range.from + startSpaces + captureGroup.length;
        tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
        tr.removeStoredMark(config.type);
      }
    }
  });
} // source: https://stackoverflow.com/a/6969486


function escapeForRegEx(string) {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function isString(value) {
  return typeof value === 'string';
}
/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */


function nodePasteRule(config) {
  return new PasteRule({
    find: config.find,
    handler: function handler(_ref113) {
      var match = _ref113.match,
          chain = _ref113.chain,
          range = _ref113.range,
          pasteEvent = _ref113.pasteEvent;
      var attributes = callOrReturn(config.getAttributes, undefined, match, pasteEvent);
      var content = callOrReturn(config.getContent, undefined, attributes);

      if (attributes === false || attributes === null) {
        return null;
      }

      var node = {
        type: config.type.name,
        attrs: attributes
      };

      if (content) {
        node.content = content;
      }

      if (match.input) {
        chain().deleteRange(range).insertContentAt(range.from, node);
      }
    }
  });
}
/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */


function textPasteRule(config) {
  return new PasteRule({
    find: config.find,
    handler: function handler(_ref114) {
      var state = _ref114.state,
          range = _ref114.range,
          match = _ref114.match;
      var insert = config.replace;
      var start = range.from;
      var end = range.to;

      if (match[1]) {
        var offset = match[0].lastIndexOf(match[1]);
        insert += match[0].slice(offset + match[1].length);
        start += offset;
        var cutOff = start - end;

        if (cutOff > 0) {
          insert = match[0].slice(offset - cutOff, offset) + insert;
          start = end;
        }
      }

      state.tr.insertText(insert, start, end);
    }
  });
}

var Tracker = /*#__PURE__*/function () {
  function Tracker(transaction) {
    _classCallCheck(this, Tracker);

    this.transaction = transaction;
    this.currentStep = this.transaction.steps.length;
  }

  _createClass(Tracker, [{
    key: "map",
    value: function map(position) {
      var deleted = false;
      var mappedPosition = this.transaction.steps.slice(this.currentStep).reduce(function (newPosition, step) {
        var mapResult = step.getMap().mapResult(newPosition);

        if (mapResult.deleted) {
          deleted = true;
        }

        return mapResult.pos;
      }, position);
      return {
        position: mappedPosition,
        deleted: deleted
      };
    }
  }]);

  return Tracker;
}();

export { CommandManager, Editor, Extension, InputRule, Mark, Node, NodePos, NodeView, PasteRule, Tracker, callOrReturn, combineTransactionSteps, createChainableState, createDocument, createNodeFromContent, createStyleTag, defaultBlockAt, deleteProps, elementFromString, escapeForRegEx, index as extensions, findChildren, findChildrenInRange, findDuplicates, findParentNode, findParentNodeClosestToPos, fromString, generateHTML, generateJSON, generateText, _getAttributes as getAttributes, getAttributesFromExtensions, getChangedRanges, getDebugJSON, getExtensionField, getHTMLFromFragment, getMarkAttributes, getMarkRange, getMarkType, getMarksBetween, getNodeAtPosition, getNodeAttributes, getNodeType, getRenderedAttributes, getSchema, getSchemaByResolvedExtensions, getSchemaTypeByName, getSchemaTypeNameByName, getSplittedAttributes, _getText as getText, getTextBetween, getTextContentFromNodes, getTextSerializersFromSchema, injectExtensionAttributesToParseRule, inputRulesPlugin, _isActive as isActive, isAtEndOfNode, isAtStartOfNode, isEmptyObject, isExtensionRulesEnabled, isFunction, isList, isMacOS, isMarkActive, isNodeActive, isNodeEmpty, isNodeSelection, isNumber, isPlainObject, isRegExp, isString, isTextSelection, isiOS, markInputRule, markPasteRule, mergeAttributes, mergeDeep, minMax, nodeInputRule, nodePasteRule, objectIncludes, pasteRulesPlugin, posToDOMRect, removeDuplicates, resolveFocusPosition, rewriteUnknownContent, selectionToInsertionEnd, splitExtensions, textInputRule, textPasteRule, textblockTypeInputRule, wrappingInputRule };